/* ============================================================
   ILLEGAL SHIRTS — THEME JS
   ============================================================ */

/* ------ HEADER: Transparent  Solid on scroll ------ */
(function() {
  const header = document.getElementById('site-header');
  if (!header) return;
  const heroSection = document.getElementById('hero-section');
  let solid = !heroSection;

  function onScroll() {
    const scrollY = document.body.style.position === 'fixed' ? -(parseFloat(document.body.style.top) || 0) : window.scrollY;
    // Fill as scrolling begins, before hero content can pass behind the nav.
    // A small dead band prevents flickering during touchpad/iOS top-edge bounce.
    solid = !heroSection || (solid ? scrollY > 0 : scrollY > 2);
    header.classList.toggle('is-solid', solid);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('pageshow', onScroll);
  onScroll();
})();

/* ------ BODY SCROLL LOCK ------
   iOS Safari ignores `overflow: hidden` on <body>, so the page behind an open
   drawer kept scrolling under the shopper's finger and lost their position.
   Pin the body with position:fixed and restore the offset on close. */
let __scrollLockY = 0;
let __scrollLockCount = 0;
let __lockedHeader = null;
function lockBodyScroll() {
  if (++__scrollLockCount > 1) return;
  __scrollLockY = window.scrollY || window.pageYOffset || 0;
  const header = document.getElementById('site-header');
  if (header?.parentElement) {
    const rect = header.getBoundingClientRect();
    __lockedHeader = { element: header, parent: header.parentElement, minHeight: header.parentElement.style.minHeight };
    header.parentElement.style.minHeight = rect.height + 'px';
    header.style.setProperty('--locked-header-top', rect.top + 'px');
    header.style.setProperty('--locked-header-width', rect.width + 'px');
    header.classList.add('is-scroll-locked');
  }
  document.body.style.position = 'fixed';
  document.body.style.top = -__scrollLockY + 'px';
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = document.documentElement.getBoundingClientRect().width + 'px';
  document.body.style.overflow = 'hidden';
}
function unlockBodyScroll() {
  if (__scrollLockCount === 0) return;
  if (--__scrollLockCount > 0) return;
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.body.style.overflow = '';
  if (__lockedHeader) {
    const { element, parent, minHeight } = __lockedHeader;
    element.classList.remove('is-scroll-locked');
    element.style.removeProperty('--locked-header-top');
    element.style.removeProperty('--locked-header-width');
    parent.style.minHeight = minHeight;
    __lockedHeader = null;
  }
  window.scrollTo({ top: __scrollLockY, left: 0, behavior: 'instant' });
}

const SurfaceScroll = {
  owners: new Set(),
  pending: new Map(),
  acquire(id) {
    clearTimeout(this.pending.get(id));
    this.pending.delete(id);
    if (this.owners.has(id)) return;
    this.owners.add(id);
    lockBodyScroll();
  },
  release(id) {
    if (!this.owners.has(id) || this.pending.has(id)) return;
    const finish = () => {
      this.pending.delete(id);
      if (this.owners.delete(id)) unlockBodyScroll();
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
    else this.pending.set(id, setTimeout(finish, 280));
  }
};
window.addEventListener('resize', () => {
  if (__scrollLockCount > 0) {
    const width = document.documentElement.getBoundingClientRect().width + 'px';
    document.body.style.width = width;
    if (__lockedHeader) {
      __lockedHeader.element.style.setProperty('--locked-header-width', width);
      __lockedHeader.parent.style.minHeight = __lockedHeader.element.getBoundingClientRect().height + 'px';
    }
  }
}, { passive: true });

/* ------ MENU DRAWER ------ */
const IllegalMenu = {
  searchTimeout: null,
  popularSearches: ['I Am Afraid Of Women', 'Do Not Narcan Me', 'Chicken Tender Slut', 'Custom shirts', 'Matching sets', 'Flags'],

  open() {
    const drawer = document.getElementById('menu-drawer');
    if (!drawer || drawer.classList.contains('open')) return;
    SurfaceScroll.acquire('menu');
    HeaderSearch.close();
    IllegalCart.close();
    drawer.inert = false;
    // Reset search state on open
    const input = document.getElementById('menu-search-input');
    if (input) input.value = '';
    this.toggleSearchMode(false);

    document.getElementById('menu-backdrop')?.classList.add('open');
    document.getElementById('menu-drawer')?.classList.add('open');
    document.getElementById('menu-open-btn')?.setAttribute('aria-expanded', 'true');
    // A desktop panel left open behind the drawer would sit over the backdrop.
    if (typeof DesktopNav !== 'undefined' && DesktopNav._closeAll) DesktopNav._closeAll();
  },

  close() {
    const drawer = document.getElementById('menu-drawer');
    if (!drawer?.classList.contains('open')) return;
    drawer.inert = true;
    document.getElementById('menu-backdrop')?.classList.remove('open');
    document.getElementById('menu-drawer')?.classList.remove('open');
    document.getElementById('menu-open-btn')?.setAttribute('aria-expanded', 'false');
    SurfaceScroll.release('menu');
  },

  switchTab(index) {
    document.querySelectorAll('.menu-tab').forEach(t => {
      const selected = t.dataset.tab == index;
      t.classList.toggle('active', selected);
      t.setAttribute('aria-selected', String(selected));
      t.tabIndex = selected ? 0 : -1;
    });
    document.querySelectorAll('.menu-tab-panel').forEach(p => {
      const selected = p.dataset.tabPanel == index;
      p.classList.toggle('active', selected);
      p.hidden = !selected;
    });
    const content = document.querySelector('#menu-drawer .menu-content');
    if (content) content.scrollTop = 0;
  },

  getRecentSearches() {
    try { return JSON.parse(localStorage.getItem('illegal_recent_searches') || '[]'); }
    catch { return []; }
  },

  addRecentSearch(term) {
    const searches = this.getRecentSearches().filter(s => s.toLowerCase() !== term.toLowerCase());
    searches.unshift(term);
    try { localStorage.setItem('illegal_recent_searches', JSON.stringify(searches.slice(0, 5))); } catch (_) {}
  },

  toggleSearchMode(hasText) {
    const defaultContent = document.getElementById('menu-default-content');
    const searchContent = document.getElementById('menu-search-content');
    const clearBtn = document.getElementById('menu-search-clear');

    if (hasText) {
      if (defaultContent) defaultContent.style.display = 'none';
      if (searchContent) searchContent.style.display = 'block';
      clearBtn?.classList.add('visible');
      this.renderSuggestions();
    } else {
      if (defaultContent) defaultContent.style.display = '';
      if (searchContent) searchContent.style.display = 'none';
      clearBtn?.classList.remove('visible');
    }
  },

  renderSuggestions() {
    const container = document.getElementById('menu-search-suggestions');
    if (!container) return;

    const recent = this.getRecentSearches();
    const clockSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
    const trendSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>';

    let html = '<div id="menu-predictive-results"></div>';

    if (recent.length > 0) {
      html += '<div class="menu-search-section-label">RECENT</div>';
      recent.forEach(term => {
        html += `<button type="button" class="menu-search-item recent" data-search-term="${term}">${clockSvg}<span>${term}</span></button>`;
      });
    }

    html += '<div class="menu-search-section-label" style="margin-top: 0.5rem;">POPULAR</div>';
    this.popularSearches.forEach(term => {
      html += `<button type="button" class="menu-search-item popular" data-search-term="${term}">${trendSvg}<span>${term}</span></button>`;
    });



    container.innerHTML = html;
  },

  async fetchPredictive(query) {
    if (query.length < 2) {
      const el = document.getElementById('menu-predictive-results');
      if (el) el.innerHTML = '';
      return;
    }

    try {
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`);
      if (!res.ok) return;
      const data = await res.json();
      if (document.getElementById('menu-search-input')?.value.trim() !== query) return;
      const products = data.resources?.results?.products || [];
      const resultsEl = document.getElementById('menu-predictive-results');
      if (!resultsEl) return;

      if (products.length === 0) {
        resultsEl.innerHTML = '';
        return;
      }

      let html = '<div class="menu-search-section-label" style="margin-top: 0.5rem;">RESULTS</div>';
      products.forEach(p => {
                let imgSrc = p.featured_image || p.image || '';
        if (imgSrc && typeof imgSrc === 'object') imgSrc = imgSrc.url || imgSrc.src || '';
        const imgUrl = imgSrc && imgSrc.startsWith('//') ? 'https:' + imgSrc : imgSrc;
        const img = imgUrl ? `<img src="${imgUrl}" alt="${p.title}" loading="lazy">` : '';
        const price = typeof p.price === 'number' ? (p.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : '$' + p.price;
        html += `<a href="${p.url}" class="menu-search-result" onclick="IllegalMenu.close()">
          ${img}
          <div>
            <div class="menu-search-result-title">${p.title}</div>
            <div class="menu-search-result-price">${price}</div>
          </div>
        </a>`;
      });
      html += `<a href="/search?q=${encodeURIComponent(query)}&type=product${document.querySelector('.search-overlay-form input[name="view"]') ? '&view=illegal-discover' : ''}" class="menu-search-view-all" onclick="IllegalMenu.close()">VIEW ALL RESULTS</a>`;

      resultsEl.innerHTML = html;
    } catch (err) {
      console.error('Predictive search error:', err);
    }
  },

  handleSearchInput(value) {
    if(document.getElementById('menu-search-input')?.dataset.discoveryBound) return;
    const hasText = value.trim().length > 0;
    this.toggleSearchMode(hasText);

    clearTimeout(this.searchTimeout);
    if (hasText) {
      this.searchTimeout = setTimeout(() => this.fetchPredictive(value.trim()), 120);
    }
  },

  clearSearch() {
    clearTimeout(this.searchTimeout);
    const input = document.getElementById('menu-search-input');
    if (input) { input.value = ''; input.dispatchEvent(new Event('input', { bubbles:true })); input.focus(); }
    this.toggleSearchMode(false);
  }
};

// Menu event listeners — run immediately since script is at end of body
(function initMenu() {
  function setup() {
    // Tab switching
    document.querySelectorAll('.menu-tab').forEach(tab => {
      tab.addEventListener('click', () => IllegalMenu.switchTab(tab.dataset.tab));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const tabs = [...document.querySelectorAll('.menu-tab')];
        const current = tabs.indexOf(tab);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        IllegalMenu.switchTab(tabs[next].dataset.tab);
        tabs[next].focus();
      });
    });

    // Search input
    document.getElementById('menu-search-input')?.addEventListener('input', e => IllegalMenu.handleSearchInput(e.target.value));

    // Clear search
    document.getElementById('menu-search-clear')?.addEventListener('click', () => IllegalMenu.clearSearch());

    // Save recent search on form submit
    document.getElementById('menu-search-form')?.addEventListener('submit', () => {
      const q = document.getElementById('menu-search-input')?.value.trim();
      if (q) IllegalMenu.addRecentSearch(q);
    });

    // Click suggestion item
    document.addEventListener('click', e => {
      const item = e.target.closest('.menu-search-item');
      if (item && item.dataset.searchTerm) {
        IllegalMenu.addRecentSearch(item.dataset.searchTerm);
        window.location.href = '/search?q=' + encodeURIComponent(item.dataset.searchTerm) + '&type=product' + (document.querySelector('.search-overlay-form input[name="view"]') ? '&view=illegal-discover' : '');
      }
    });

    // ESC key: close menu
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') IllegalMenu.close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

/* ------ PREDICTIVE SEARCH (reusable) ------
   Any <input data-predictive-search="resultsId"> gets a live dropdown.
   Uses Shopify's /search/suggest.json — the same endpoint the menu drawer uses. */
/* ------ DESKTOP NAVIGATION ------
   Top-level links live in the header on large screens; anything with children
   opens a panel. Three things this has to get right:

     - Pointer AND keyboard. A hover-only menu is unusable with a keyboard, and
       a click-only one feels broken with a mouse. Hover opens, click toggles,
       Escape closes, and moving focus out of the item closes it.
     - The panel must not close while the pointer travels from the trigger to
       the panel. The trigger is full header height and the panel butts against
       it, so there is no gap to fall through; the close is also delayed.
     - The parent destination must stay reachable. The trigger is a button, so
       the panel carries an explicit "ALL <SECTION>" link — losing the parent
       link is the standard failure of this pattern. */
const DesktopNav = {
  _closeTimer: null,

  init() {
    const nav = document.getElementById('site-nav');
    if (!nav || this._bound) return;
    this._bound = true;

    // A menu of flat links with no children is a valid menu — it just has no
    // panels to wire up. Measuring still has to happen for it to be shown.
    const items = Array.from(nav.querySelectorAll('.site-nav-item.has-panel'));

    const panelOf = (item) => item.querySelector('[data-nav-panel]');
    const toggleOf = (item) => item.querySelector('[data-nav-toggle]');

    const header = document.getElementById('site-header');
    const backdrop = document.getElementById('desktop-nav-backdrop');
    const motion = () => !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const animations = new WeakMap();
    let openTimer = null;
    let pinnedItem = null;
    const updateSurface = () => {
      const isOpen = items.some(item => toggleOf(item)?.getAttribute('aria-expanded') === 'true');
      header?.classList.toggle('is-nav-open', isOpen);
      backdrop?.classList.toggle('is-open', isOpen);
      if (isOpen && header) document.documentElement.style.setProperty('--desktop-nav-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
    };
    const hide = (item, animate = false) => {
      const panel = panelOf(item);
      const toggle = toggleOf(item);
      if (!panel || panel.hidden) return;
      animations.get(panel)?.cancel();
      toggle?.setAttribute('aria-expanded', 'false');
      panel.inert = true;
      if (pinnedItem === item) pinnedItem = null;
      if (animate && motion() && panel.animate) {
        const animation = panel.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 150, easing: 'ease-out', fill: 'both' });
        animations.set(panel, animation);
        animation.finished.then(() => {
          if (animations.get(panel) !== animation) return;
          panel.hidden = true;
          animation.cancel();
          animations.delete(panel);
        }).catch(() => {});
      } else {
        panel.hidden = true;
        animations.delete(panel);
      }
    };
    const closeAll = (except) => {
      clearTimeout(openTimer);
      clearTimeout(this._closeTimer);
      items.forEach(item => { if (item !== except) hide(item); });
      updateSurface();
    };
    const open = (item, pin = false) => {
      if (window.innerWidth < 1024) return;
      clearTimeout(openTimer);
      clearTimeout(this._closeTimer);
      if (pin) pinnedItem = item;
      const panel = panelOf(item);
      const toggle = toggleOf(item);
      if (!panel || toggle?.getAttribute('aria-expanded') === 'true') return;
      if (typeof HeaderSearch !== 'undefined') HeaderSearch.close();
      closeAll(item);
      animations.get(panel)?.cancel();
      panel.hidden = false;
      panel.inert = false;
      toggle?.setAttribute('aria-expanded', 'true');
      updateSurface();
      if (motion() && panel.animate) {
        const animation = panel.animate([{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 260, easing: 'cubic-bezier(.22,1,.36,1)' });
        animations.set(panel, animation);
        animation.finished.then(() => { if (animations.get(panel) === animation) animations.delete(panel); }).catch(() => {});
      }
    };
    const close = (item) => {
      clearTimeout(openTimer);
      clearTimeout(this._closeTimer);
      hide(item, true);
      updateSurface();
    };
    this._closeAll = () => closeAll(null);
    window.addEventListener('scroll', updateSurface, { passive: true });

    /* ---- Does it actually fit? ----
       The logo is centred and absolutely positioned, so a menu one item too
       long would quietly run underneath it. Measure the row against the gap
       before the logo; the CSS keys off the result and nothing else, so with
       JS off the header is exactly the drawer-only header it has always been.

       Not a single yes/no. A first pass at comfortable spacing, then a tighter
       one, and only then the drawer — one link over the line should cost some
       letter-spacing, not the whole navigation. */
    const row = nav.querySelector('.site-nav-row');
    const logo = document.querySelector('[data-header-logo]');
    const DENSITIES = ['comfortable', 'tight'];

    const measure = () => {
      if (!header || !row) return null;
      if (window.innerWidth < 1024) {
        header.setAttribute('data-nav-fits', 'false');
        header.setAttribute('data-nav-why', 'below the desktop breakpoint');
        closeAll(null);
        return { fits: false, reason: 'below the desktop breakpoint' };
      }

      // Show it in order to measure it. Every write here happens inside one
      // task, so nothing paints in between and there is no flash of a nav that
      // is about to be hidden again.
      header.setAttribute('data-nav-fits', 'true');
      let last = null;
      for (let i = 0; i < DENSITIES.length; i++) {
        header.setAttribute('data-nav-density', DENSITIES[i]);
        const navLeft = nav.getBoundingClientRect().left;
        const logoLeft = logo ? logo.getBoundingClientRect().left : window.innerWidth / 2;
        const room = Math.round(logoLeft - navLeft - 16);
        const needed = row.scrollWidth;
        last = { fits: needed <= room, needed: needed, room: room, density: DENSITIES[i] };
        if (last.fits) {
          header.setAttribute('data-nav-why', 'fits at ' + DENSITIES[i] + ' spacing');
          return last;
        }
      }

      header.setAttribute('data-nav-fits', 'false');
      header.setAttribute('data-nav-density', DENSITIES[0]);
      last.reason = 'the menu needs ' + last.needed + 'px and there is only '
        + last.room + 'px before the logo — remove a top-level item or shorten one';
      header.setAttribute('data-nav-why', last.reason);
      closeAll(null);
      return last;
    };

    /* One line in the console answers "why is the hamburger still showing?"
       without anyone having to guess: DesktopNav.diagnose() */
    this.diagnose = () => {
      const result = measure() || {};
      return {
        sections: nav.querySelectorAll('.site-nav-item').length,
        withPanels: items.length,
        needsPx: result.needed,
        roomPx: result.room,
        showing: header && header.getAttribute('data-nav-fits') === 'true',
        why: header && header.getAttribute('data-nav-why')
      };
    };

    this._measure = measure;
    measure();

    // Only rendered in the theme editor — see sections/header.liquid.
    const note = document.getElementById('nav-fit-note');
    if (note) note.textContent = header.getAttribute('data-nav-why') || '';

    let fitTimer = null;
    window.addEventListener('resize', () => {
      clearTimeout(fitTimer);
      fitTimer = setTimeout(measure, 60);
    });

    if (!items.length) return;

    items.forEach((item) => {
      const toggle = toggleOf(item);
      if (!toggle) return;

      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        // A click after hover pins the menu instead of unexpectedly closing it.
        if (isOpen && pinnedItem === item) close(item); else open(item, true);
      });
      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'touch' || !window.matchMedia('(hover: hover)').matches) return;
        clearTimeout(this._closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(() => open(item), 140);
      });
      item.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'touch' || !window.matchMedia('(hover: hover)').matches) return;
        clearTimeout(openTimer);
        clearTimeout(this._closeTimer);
        this._closeTimer = setTimeout(() => {
          // Keyboard users can continue browsing an open panel independently of the pointer.
          if (!panelOf(item)?.contains(document.activeElement)) close(item);
        }, 220);
      });

      // Tabbing past the last link in a panel should close it, not leave an
      // open panel floating over the page.
      item.addEventListener('focusout', (e) => {
        if (item.contains(e.relatedTarget)) return;
        close(item);
      });

      item.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          close(item);
          toggle.focus({ preventScroll: true });
        }
        if (e.key === 'ArrowDown' && e.target === toggle) {
          e.preventDefault();
          open(item, true);
          panelOf(item)?.querySelector('a')?.focus({ preventScroll: true });
        }
        if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && e.target === toggle) {
          e.preventDefault();
          const next = items[(items.indexOf(item) + (e.key === 'ArrowRight' ? 1 : items.length - 1)) % items.length];
          toggleOf(next)?.focus({ preventScroll: true });
          open(next, true);
        }
      });
    });

    document.addEventListener('click', (e) => {
      if (!nav.contains(e.target)) closeAll(null);
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => DesktopNav.init());
} else {
  DesktopNav.init();
}

/* ------ HEADER SEARCH OVERLAY ------
   The predictive search and the paginated search page were both already built;
   nothing in the chrome pointed at either, so the only way in was to type the
   /search URL. This is the entry point. The input itself carries
   data-predictive-search, so the module above wires it with no extra work. */
const HeaderSearch = {
  position() {
    const header = document.getElementById('site-header');
    const top = Math.max(0, header?.getBoundingClientRect().bottom || 0);
    for (const id of ['search-overlay', 'search-backdrop']) document.getElementById(id)?.style.setProperty('--search-top', top + 'px');
  },
  open() {
    const overlay = document.getElementById('search-overlay');
    if (!overlay || overlay.classList.contains('is-open')) return;

    IllegalMenu.close();
    IllegalCart.close();
    DesktopNav._closeAll?.();
    this.position();
    overlay.inert = false;
    document.getElementById('site-header')?.classList.add('is-search-open');
    document.getElementById('search-backdrop')?.classList.add('is-open');
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.getElementById('header-search-open')?.setAttribute('aria-expanded', 'true');
    const input = document.getElementById('header-search-input');
    if (input) { input.focus({ preventScroll: true }); input.select(); }
  },

  close() {
    const overlay = document.getElementById('search-overlay');
    if (!overlay?.classList.contains('is-open')) return;
    overlay.inert = true;
    document.getElementById('search-backdrop')?.classList.remove('is-open');
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.getElementById('site-header')?.classList.remove('is-search-open');

    const trigger = document.getElementById('header-search-open');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      // Send focus back where it came from rather than dropping it on <body>.
      trigger.focus({ preventScroll: true });
    }
  },

  toggle() {
    const overlay = document.getElementById('search-overlay');
    if (!overlay) return;
    if (overlay.classList.contains('is-open')) this.close();
    else this.open();
  },

  init() {
    if (this._bound) return;
    this._bound = true;
    document.getElementById('header-search-open')?.addEventListener('click', () => this.toggle());
    document.getElementById('header-search-close')?.addEventListener('click', () => this.close());
    document.getElementById('search-backdrop')?.addEventListener('click', () => this.close());
    document.addEventListener('click', e => { if (!e.target.closest('#search-overlay,#header-search-open')) this.close(); });
    window.addEventListener('resize', () => {
      if (document.getElementById('search-overlay')?.classList.contains('is-open')) this.position();
    }, { passive: true });
    // Escape closes even when focus sits inside the predictive dropdown. The
    // input's own Escape handler only hides the results list.
    document.getElementById('search-overlay')?.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => HeaderSearch.init());
} else {
  HeaderSearch.init();
}


/* ------ CART DRAWER ------ */
const IllegalCart = {
  // Set once /cart.js has been read this page view. Lets us skip the request
  // on load when Liquid already told us the cart is empty, without ever
  // showing a stale drawer: the first open fetches if nothing has yet.
  _loaded: false,
  get controller() { return window.CartPurchase?.controller; },

  open() {
    if (!this.controller) { location.assign(window.IllegalShirts.routes.cart_url); return; }
    const drawer = document.getElementById('cart-drawer');
    if (!drawer || drawer.classList.contains('open')) return;
    SurfaceScroll.acquire('cart');
    IllegalMenu.close();
    HeaderSearch.close();
    drawer.inert = false;
    document.getElementById('cart-overlay')?.classList.add('open');
    document.getElementById('cart-drawer')?.classList.add('open');
    this.refresh();
  },
  close() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer?.classList.contains('open')) return;
    drawer.inert = true;
    document.getElementById('cart-overlay')?.classList.remove('open');
    document.getElementById('cart-drawer')?.classList.remove('open');
    SurfaceScroll.release('cart');
  },

  async refresh() {
    if (!this.controller) return;
    try { await this.controller.refresh(); this._loaded = true; } catch (_) {}
  },

  render(cart) {
    // Header count lives outside the drawer, so it stays global. Route it
    // through the shared helper — writing textContent directly left a "0"
    // chip visible whenever a refresh came back with an empty cart, and never
    // updated the screen-reader label beside it.
    syncHeaderCartCount(cart.item_count);
    try { window.CartRewards?.render(cart); } catch (_) {}

    // Everything below MUST be scoped to the drawer. Otherwise, if the cart
    // page template reuses any of these IDs (#cart-lines, #cart-empty, etc.),
    // getElementById returns the cart PAGE element (first in document order)
    // and this renderer overwrites the cart page with drawer markup — which is
    // what made "everything disappear" on quantity change.
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    const drawerCount = drawer.querySelector('#cart-drawer-count');
    if (drawerCount) drawerCount.textContent = cart.item_count;

    const empty = drawer.querySelector('#cart-empty');
    const lines = drawer.querySelector('#cart-lines');
    const foot = drawer.querySelector('#cart-foot');

    if (cart.item_count === 0) {
      if (empty) empty.style.display = '';
      if (lines) lines.innerHTML = '';
      if (foot) foot.style.display = 'none';
      return;
    }

    if (empty) empty.style.display = 'none';
    if (foot) foot.style.display = '';

    // Render line items
    if (lines) {
      lines.innerHTML = cart.items.map(item => `
        <div class="cart-line" data-key="${item.key}">
          <div class="cart-line-img">
            ${item.image ? `<img src="${escapeHtml(sizedImageUrl(item.image, 160))}" alt="${escapeHtml(item.title)}" loading="lazy">` : ''}
          </div>
          <div class="cart-line-info">
            <div class="cart-line-title">${escapeHtml(item.product_title)}</div>
            <div class="cart-line-variant">${escapeHtml(item.variant_title || '')}</div>
            ${renderLineItemProperties(item.properties)}
            <div class="cart-line-controls">
              <div class="cart-line-stepper">
                <button onclick="IllegalCart.updateItem('${item.key}', IllegalCart.controller.desired('${item.key}') - 1)" aria-label="Decrease">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg>
                </button>
                <input type="number" min="0" step="1" inputmode="numeric" class="cart-line-stepper-val" data-drawer-quantity data-key="${item.key}" value="${this.controller?.desired(item.key) ?? item.quantity}" aria-label="Quantity for ${escapeHtml(item.product_title)}">
                <button onclick="IllegalCart.updateItem('${item.key}', IllegalCart.controller.desired('${item.key}') + 1)" aria-label="Increase">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
                </button>
              </div>
              <button class="cart-line-remove" onclick="IllegalCart.updateItem('${item.key}', 0)">REMOVE</button>
            </div>
          </div>
          <div class="cart-line-price">${formatMoney(item.final_line_price)}</div>
        </div>
      `).join('');
    }

    // Update totals
    // Update totals (scoped to drawer, same reason as above)
    const savings = Math.max(0, cart.original_total_price - cart.total_price);
    try { window.CartRewards?.images(drawer); } catch (_) {}
    const subtotal = drawer.querySelector('#cart-subtotal');
    const total = drawer.querySelector('#cart-total');
    if (subtotal) subtotal.textContent = formatMoney(cart.original_total_price);
    if (total) total.textContent = formatMoney(cart.total_price);
  },

  updateItem(key, quantity) {
    return this.controller?.change(key, Math.max(0, quantity));
  },

  addItem(variantId, quantity) {
    const item = { id: variantId, quantity: quantity || 1 };
    return this.controller.add({ items: [item] }, [item], 'variant:' + variantId);
  },

  addFromForm(form) {
    return window.CartPurchase.addFromForm(form);
  }

};

/* ------ MONEY FORMATTER ------ */
function formatMoney(cents) {
  return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.CartPurchase?.controller.cart.currency || window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
}

/* ------ LINE ITEM PROPERTIES (bundle contents, customizations, etc.) ------ */
function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));
}

function renderLineItemProperties(properties) {
  if (!properties) return '';
  // /cart.js returns properties as an object; older responses use [key, value] pairs.
  const entries = Array.isArray(properties) ? properties : Object.entries(properties);
  const visible = entries.filter(([key, value]) => {
    return value !== '' && value != null && String(key).charAt(0) !== '_';
  });
  if (!visible.length) return '';
  return '<div class="cart-line-props">' + visible.map(([key, value]) =>
    `<div class="cart-line-prop"><span class="cart-line-prop-key">${escapeHtml(key)}:</span> ${escapeHtml(value)}</div>`
  ).join('') + '</div>';
}

/* ------ PRODUCT .js URL NORMALIZER ------
   Shopify appends tracking params (pr_prod_strat, pr_seq, pr_ref_pid, ...) to
   product.url on recommendation/related sections. Liquid builds data-product-url
   as "{{ product.url }}.js", so on those sections the ".js" can land INSIDE a
   query value ("/products/handle?pr_seq=uniform.js") — the endpoint then returns
   HTML, res.json() throws, and the fetch silently fails.

   This strips any query/hash and any stray ".js", then re-appends a clean ".js"
   so every caller hits "/products/handle.js" regardless of tracking params.
   Single source of truth — used by QuickAdd, card swatches, and anywhere else. */
function cleanProductJsUrl(url) {
  if (!url) return '';
  return url.split('?')[0].split('#')[0].replace(/\.js$/, '') + '.js';
}

/* Resize a Shopify CDN image URL to a target width (keeps card downloads small). */
function sizedImageUrl(url, width) {
  if (!url) return url;
  // Drop an existing width param so we don't end up with two.
  const cleaned = url.replace(/([?&])width=\d+/i, '$1').replace(/[?&]$/, '');
  return cleaned.includes('?') ? cleaned + '&width=' + width : cleaned + '?width=' + width;
}

/* ------ CART TOAST ------ */
let cartToastTimer = null;
/* Header cart badge: hide the bubble at zero (a red "0" reads as an error) and
   keep the screen-reader label truthful. */
function syncHeaderCartCount(count) {
  const bubble = document.getElementById('header-cart-count');
  if (bubble) {
    bubble.textContent = count;
    bubble.style.display = count > 0 ? '' : 'none';
  }
  const label = document.getElementById('header-cart-count-label');
  if (label) label.textContent = count + ' item' + (count === 1 ? '' : 's') + ' in cart';
}

/* Failure counterpart to showCartToast. The sticky add buttons can sit far from
   the buy box, so an inline note alone was invisible: on error the label just
   snapped back to ADD TO CART and nothing else happened. */
function showErrorToast(message) {
  const toast = document.getElementById('cart-toast');
  const textEl = document.getElementById('cart-toast-text');
  if (!toast || !textEl) return;
  textEl.textContent = message || 'Could not add that to your cart.';
  toast.classList.add('is-error');
  clearTimeout(cartToastTimer);
  toast.classList.add('is-visible');
  cartToastTimer = setTimeout(() => {
    toast.classList.remove('is-visible');
    toast.classList.remove('is-error');
  }, 5000);
}

function showCartToast(title, qty) {
  const toast = document.getElementById('cart-toast');
  const textEl = document.getElementById('cart-toast-text');
  if (!toast || !textEl) return;
  const qtyText = qty > 1 ? qty + 'x ' : '';
  textEl.textContent = qtyText + title.toUpperCase() + ' ADDED';
  toast.classList.remove('is-error');
  clearTimeout(cartToastTimer);
  toast.classList.add('is-visible');
  cartToastTimer = setTimeout(() => { toast.classList.remove('is-visible'); }, 3500);
}

/* ------ NEWSLETTER FORMS ------
   Shopify round-trips these through a page load, so the only things missing
   were a pending state on submit and focus moving to the result on return. */
(function () {
  document.querySelectorAll('form[action*="/contact"], form#newsletter-form, form#footer-newsletter')
    .forEach((form) => {
      form.addEventListener('submit', () => {
        const btn = form.querySelector('button[type="submit"]');
        if (!btn || btn.dataset.busy) return;
        btn.dataset.busy = '1';
        btn.classList.add('is-submitting');
        btn.disabled = true;
        btn.dataset.originalHtml = btn.innerHTML;
        btn.textContent = 'JOINING…';
      });
    });

  // After the redirect, put focus on the outcome so screen readers announce it
  const note = document.querySelector('.form-note');
  if (note && /customer_posted/.test(window.location.search)) {
    note.focus({ preventScroll: false });
  }
})();

/* Toast "VIEW CART" and the header cart icon open the drawer rather than
   navigating. The href remains a working fallback without JS. */
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-open-cart-drawer]');
  if (!trigger) return;
  const drawer = document.getElementById('cart-drawer');
  if (!drawer || typeof IllegalCart === 'undefined' || !IllegalCart.open) return;  // let the link work
  if (document.body.classList.contains('template-cart')) return;                    // already there
  e.preventDefault();
  const toast = document.getElementById('cart-toast');
  if (toast) toast.classList.remove('is-visible');
  IllegalCart.open();
});

/* Called after every successful add. The cart drawer is the real confirmation:
   it shows what is in the cart, the free-shipping progress and the route to
   checkout. Fall back to the toast only when the drawer is switched off, and
   never toast on the cart page itself — there the page already updates. */
function onAddedToCart(title, qty) {
  const drawer = document.getElementById('cart-drawer');
  const onCartPage = document.body.classList.contains('template-cart');

  // On the cart page the drawer and the toast are both wrong — the page in
  // front of the shopper is the cart. It has to actually change, which it
  // previously did not: the add succeeded and the page stayed exactly as it
  // was, so the click read as a no-op.
  if (onCartPage) {
    if (typeof CartPage !== 'undefined' && CartPage.refreshFromServer) CartPage.refreshFromServer();
    else window.location.reload();
    return;
  }

  if (drawer && typeof IllegalCart !== 'undefined' && IllegalCart.open) {
    IllegalCart.open();
    return;
  }
  showCartToast(title, qty);
}

/* ------ FEATURED COLLECTION PILLS ------------------------------------------
   Pills on the homepage's featured-collection section. Each pill is an <a>
   pointing at /collections/{handle}; this module intercepts the click and
   AJAX-swaps the section's grid by fetching that collection page and lifting
   the first N .product-card nodes out of #cp-product-grid. The collection
   page uses the same product-card snippet as the homepage, so swatch, quick
   add, and card link behavior all work identically on the freshly-injected
   cards (those handlers are document-delegated).

   If a request fails, the collection link remains the navigation fallback. If JS doesn't run at
   all, clicking a pill just navigates to that collection page via the href.
   --------------------------------------------------------------------------- */
const FeaturedPills = {
  _bound: false,
  _cache: {}, // handle  array of card outerHTML strings

  init() {
    if (this._bound) return;
    this._bound = true;

    document.addEventListener('click', (e) => {
      const pill = e.target.closest('[data-fc-pill]');
      if (!pill) return;
      // Modified clicks (cmd-click, middle-click) should open the collection
      // page in a new tab, not AJAX-swap. Let them through.
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      this.swap(pill);
    });

    // Prefetch on hover. Same idea as the swatch prefetch: by the time someone
    // clicks, the response is usually already cached for the transition.
    document.addEventListener('mouseenter', (e) => {
      const pill = e.target && e.target.closest ? e.target.closest('[data-fc-pill]') : null;
      if (!pill || pill.classList.contains('filter-active')) return;
      this.prefetch(pill.dataset.fcPill);
    }, true);
  },

  // Extract product-card nodes from a collection page response. Tries the
  // known collection-page grid first; falls back to whatever grid contains
  // .product-card children if a theme change ever renamed that ID.
  _extractCards(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    let source = doc.getElementById('cp-product-grid');
    if (!source) {
      const firstCard = doc.querySelector('.product-card');
      source = firstCard ? firstCard.parentElement : null;
    }
    if (!source) return [];
    const cards = source.querySelectorAll(':scope > .product-card');
    return Array.from(cards).map(c => c.outerHTML);
  },

  _pending: {},
  _animations: new WeakMap(),

  async _load(handle) {
    if (this._cache[handle]?.length) return this._cache[handle];
    if (!this._pending[handle]) {
      this._pending[handle] = (async () => {
        const res = await fetch('/collections/' + encodeURIComponent(handle) + (handle === 'new-arrivals' ? '?sort_by=created-descending' : ''));
        if (!res.ok) throw new Error('Featured collection fetch failed: ' + res.status);
        const cards = this._extractCards(await res.text());
        if (!cards.length) throw new Error('No product cards in collection ' + handle);
        return (this._cache[handle] = cards);
      })().finally(() => { delete this._pending[handle]; });
    }
    return this._pending[handle];
  },

  async prefetch(handle) {
    if (!handle) return;
    try { await this._load(handle); } catch (_) { /* A click can retry. */ }
  },

  async _prepareImages(fragment) {
    // Warm only the first visible row, using the same responsive sources as the cards.
    // A slow image must never hold the collection switch indefinitely.
    const images = Array.from(fragment.querySelectorAll('.product-card-img')).slice(0, 4);
    let timer;
    const ready = Promise.all(images.map(source => {
      const image = new Image();
      image.sizes = source.sizes;
      image.srcset = source.srcset;
      image.src = source.src;
      return image.decode().catch(() => {});
    }));
    await Promise.race([ready, new Promise(resolve => { timer = setTimeout(resolve, 900); })]);
    clearTimeout(timer);
  },

  _cancelAnimations(grid) {
    (this._animations.get(grid) || []).forEach(animation => animation.cancel());
    this._animations.delete(grid);
    grid.inert = false;
  },

  async swap(pill) {
    const section = pill.closest('[data-fc-section]');
    const grid = section?.querySelector('[data-fc-grid]');
    const handle = pill.dataset.fcPill;
    if (!grid || !handle) return;
    const request = (Number(section.dataset.fcRequest) || 0) + 1;
    section.dataset.fcRequest = String(request);
    const isCurrent = () => Number(section.dataset.fcRequest) === request;
    this._cancelAnimations(grid);

    const pills = Array.from(section.querySelectorAll('[data-fc-pill]'));
    const initial = pills.find(item => item.classList.contains('filter-active'));
    if (!section.dataset.fcCurrent && initial) {
      section.dataset.fcCurrent = initial.dataset.fcPill;
      this._cache[initial.dataset.fcPill] = Array.from(grid.children).map(card => card.outerHTML);
    }
    const status = section.querySelector('[data-fc-status]');
    pills.forEach(item => item.classList.toggle('filter-active', item === pill));
    // Returning to the displayed collection also invalidates any pending request.
    if (section.dataset.fcCurrent === handle) {
      pills.forEach(item => item.setAttribute('aria-current', item === pill ? 'true' : 'false'));
      grid.setAttribute('aria-busy', 'false');
      if (status) status.textContent = pill.textContent.trim();
      return;
    }
    grid.setAttribute('aria-busy', 'true');
    if (status) status.textContent = status.dataset.loading || 'Loading designs…';

    try {
      const cards = await this._load(handle);
      if (!isCurrent()) return;
      const template = document.createElement('template');
      template.innerHTML = cards.slice(0, parseInt(section.dataset.fcLimit || '12', 10)).join('');
      await this._prepareImages(template.content);
      if (!isCurrent()) return;

      const motion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches && !!grid.animate;
      const previousHeight = grid.getBoundingClientRect().height;
      if (motion) {
        grid.inert = true;
        const fade = grid.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 160, easing: 'ease-in', fill: 'both' });
        this._animations.set(grid, [fade]);
        await fade.finished.catch(() => {});
        if (!isCurrent()) return;
      }

      grid.replaceChildren(template.content);
      section.dataset.fcCurrent = handle;
      pills.forEach(item => item.setAttribute('aria-current', item === pill ? 'true' : 'false'));
      const viewAll = section.querySelector('[data-fc-view-all]');
      if (viewAll) {
        viewAll.href = pill.href;
        viewAll.textContent = (viewAll.dataset.label || 'Shop the full collection') + ' ';
      }
      section.dispatchEvent(new CustomEvent('featured:updated'));
      if (motion) {
        const nextHeight = grid.getBoundingClientRect().height;
        this._cancelAnimations(grid);
        grid.inert = true;
        const reveal = grid.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' });
        const animations = [reveal];
        // Expanded grids settle to the new row count instead of snapping the page upward.
        if (Math.abs(previousHeight - nextHeight) > 1) {
          animations.push(grid.animate([{ height: previousHeight + 'px' }, { height: nextHeight + 'px' }], { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' }));
        }
        this._animations.set(grid, animations);
        await Promise.all(animations.map(animation => animation.finished.catch(() => {})));
        if (!isCurrent()) return;
      }
      if (status) status.textContent = pill.textContent.trim();
    } catch (err) {
      if (!isCurrent()) return;
      console.error('Featured collection swap failed:', err);
      pills.forEach(item => item.classList.toggle('filter-active', item.dataset.fcPill === section.dataset.fcCurrent));
      const href = pill.getAttribute('href');
      if (href) window.location.assign(href);
    } finally {
      if (isCurrent()) {
        this._cancelAnimations(grid);
        grid.setAttribute('aria-busy', 'false');
      }
    }
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => FeaturedPills.init());
} else {
  FeaturedPills.init();
}


/* ------ PRODUCT PAGE —— Full PDP Controller ------ */
const PDP = {
  product: null,
  selectedOptions: {},
  currentImageIndex: 0,
  qty: 1,

  init() {
    const jsonEl = document.getElementById('product-json');
    if (!jsonEl || !window.CartPurchase || this._initialized) return;
    this._initialized = true;
    this.product = window.ProductColorMatches?.apply(JSON.parse(jsonEl.textContent)) || JSON.parse(jsonEl.textContent);
    const form = document.getElementById('product-form');
    if (!form) return;
    form.dataset.purchaseKind = form.querySelector('[data-purchase-kind]')?.dataset.purchaseKind || 'standard';

    // Per-template flag: when the buy button carries data-skip-size-gate, this
    // PDP belongs to a product where size isn't a traditional variant (custom
    // builders, bundle products, app-controlled selection). Treat size as
    // already chosen so the button renders ADD TO CART, the form submits
    // without shaking, and the sticky bars behave normally.
    this.skipSizeGate = document.getElementById('add-to-cart-btn')?.dataset.skipSizeGate === 'true';

    // Seed from the variant the SERVER rendered, not the first available one.
    // Liquid renders product.selected_or_first_available_variant, so a
    // ?variant= deep link displays that variant's colour as selected while JS
    // used to seed a different one — and the first updateVariant() then wrote
    // the wrong variant id into the form. Shoppers added a colour they had not
    // chosen.
    const seedEl = document.getElementById('pdp-selected-variant');
    let seedId = null;
    if (seedEl) { const n = parseInt(seedEl.textContent.trim(), 10); if (isFinite(n)) seedId = n; }
    const firstAvailable =
      (seedId && this.product.variants.find(v => v.id === seedId)) ||
      this.product.variants.find(v => v.available) ||
      this.product.variants[0];
    // Option names come from the merchant, so "Size", "size" and "SIZE" are all
    // possible. Matching the literal 'Size' meant a lowercase option turned the
    // size gate off entirely — hasSize was false, sizeSelected defaulted true,
    // and the shopper could add to cart without choosing one. Compare on the
    // normalised name everywhere; Liquid stamps the same idea as
    // data-option-role so the DOM selectors agree.
    const isSizeName = (o) => String(o).toLowerCase().trim() === 'size';
    const hasSize = this.product.options.some(isSizeName);
    const explicitVariant = seedEl?.dataset.explicit === 'true';
    this.sizeSelected = this.skipSizeGate || !hasSize || explicitVariant;
    this.product.options.forEach((opt, i) => {
      if (isSizeName(opt) && !this.skipSizeGate && !explicitVariant) {
        this.selectedOptions[opt] = null;
      } else {
        this.selectedOptions[opt] = firstAvailable['option' + (i + 1)];
      }
    });

    // Force-clear any size pre-selection from Shopify (skip when the gate is
    // bypassed — we want the default selection visible there).
    if (hasSize && !this.skipSizeGate && !explicitVariant) {
      this.sizePills(form).forEach(b => { b.classList.remove('is-selected'); });
      const sizeLabel = document.getElementById('selected-size');
      if (sizeLabel) sizeLabel.textContent = '';
    }

    form.querySelectorAll('.product-option-btn').forEach(button => {
      button.classList.toggle('is-selected', this.selectedOptions[button.dataset.optionName] === button.dataset.optionValue);
      button.setAttribute('aria-pressed', String(button.classList.contains('is-selected')));
    });
    this.initVariantSwitching(form);
    document.querySelector('.pdp-product-facts a')?.addEventListener('click', () => {
      const details = document.getElementById('pdp-fabric-details');
      if (details) details.open = true;
    });
    this.curateGallery();
    this.initGallery();
    this.initMobileRail();
    this.initQuantity();
    this.initStickyBars();
    this.initSizeGuideModal();
    this.initZoom();
    this.initShare();
    this.initStackAndSave();
    this.initFormSubmit(form);
    this.initStickyAddButtons();
    this.updateVariant();
    this.updateCtaState();
    form.classList.add('pdp-options-ready');
    // The enhanced size gate provides a visible prompt; retain native required
    // validation only while the native selector is the active purchase UI.
    const nativeVariant = form.querySelector('select#variant-id');
    if (nativeVariant) nativeVariant.required = false;

  },

  /* ---- Every size pill, whatever the merchant capitalised the option as ----
     Prefers the role Liquid stamps; falls back to the name for any markup that
     predates it. */
  sizePills(form) {
    const scope = form || document;
    const byRole = scope.querySelectorAll('.product-option-btn[data-option-role="size"]');
    if (byRole.length) return Array.from(byRole);
    return Array.from(scope.querySelectorAll('.product-option-btn')).filter(
      b => String(b.dataset.optionName || '').toLowerCase().trim() === 'size'
    );
  },

  isSizeButton(btn) {
    if (btn.dataset.optionRole) return btn.dataset.optionRole === 'size';
    return String(btn.dataset.optionName || '').toLowerCase().trim() === 'size';
  },

  /* ---- Variant Switching ---- */
  initVariantSwitching(form) {
    const buttons = form.querySelectorAll('.product-option-btn');
    buttons.forEach(btn => {
      if (btn.classList.contains('pdp-swatch')) {
        const label = btn.closest('.pdp-option').querySelector('.pdp-option-value');
        const preview = () => { if (label) label.textContent = btn.dataset.optionValue; };
        const restore = () => { if (label) label.textContent = this.selectedOptions[btn.dataset.optionName] || ''; };
        btn.addEventListener('mouseenter', preview);
        btn.addEventListener('mouseleave', restore);
        btn.addEventListener('focus', preview);
        btn.addEventListener('blur', restore);
      }
      btn.addEventListener('click', () => {
        const optName = btn.dataset.optionName;
        const optValue = btn.dataset.optionValue;
        if (btn.disabled) return;
        this.selectedOptions[optName] = optValue;

        const isSize = this.isSizeButton(btn);

        // Track size selection
        if (isSize) {
          this.sizeSelected = true;
          this.clearSizePrompt();
          this.updateCtaState();
        }

        // Update button states
        form.querySelectorAll('.product-option-btn[data-option-name="' + optName + '"]').forEach(b => {
          const sel = b.dataset.optionValue === optValue;
          b.classList.toggle('is-selected', sel);
          b.setAttribute('aria-pressed', String(sel));
        });

        // Update label
        const label = document.getElementById('selected-' + optName.toLowerCase().replace(/\s+/g, '-'));
        if (label) label.textContent = optValue;

        // Size availability is colour-specific, so recompute it whenever the
        // colour changes. Liquid renders it for the initially selected colour
        // only; without this, sizes stocked in the newly chosen colour would
        // stay disabled (and sold-out ones would stay clickable).
        if (!isSize) this.refreshSizeAvailability(form);

        this.updateVariant();
      });
    });
  },

  /* ---- Recompute which sizes are buyable in the selected colour ---- */
  refreshSizeAvailability(form) {
    const sizePills = this.sizePills(form);
    if (!sizePills.length) return;

    const optIndexOf = (name) =>
      this.product.options.findIndex(o => String(o).toLowerCase().trim() === name);
    const sizeIdx = optIndexOf('size');
    if (sizeIdx === -1) return;

    // Every non-size option that is currently chosen must match
    const fixed = [];
    this.product.options.forEach((opt, i) => {
      if (i === sizeIdx) return;
      const val = this.selectedOptions[opt];
      if (val) fixed.push([i, val]);
    });

    sizePills.forEach(pill => {
      const value = pill.dataset.optionValue;
      const buyable = this.product.variants.some(v => {
        if (v['option' + (sizeIdx + 1)] !== value) return false;
        if (!v.available) return false;
        return fixed.every(([i, val]) => v['option' + (i + 1)] === val);
      });
      pill.disabled = !buyable;
      pill.classList.toggle('is-disabled', !buyable);
      // If the chosen size just became unavailable in this colour, drop it and
      // re-gate the CTA rather than leaving an unbuyable selection standing.
      if (!buyable && pill.classList.contains('is-selected')) {
        pill.classList.remove('is-selected');
        pill.setAttribute('aria-pressed', 'false');
        const label = document.getElementById('selected-' + this.product.options[sizeIdx].toLowerCase().replace(/\s+/g, '-'));
        if (label) label.textContent = '';
        this.selectedOptions[this.product.options[sizeIdx]] = null;
        this.sizeSelected = this.skipSizeGate;
        this.updateCtaState();
      }
    });
  },

  updateVariant() {
    const product = this.product;

    // Find exact variant match (all options selected)
    const variant = this.currentVariant();

    // Even without a full variant match, switch images for partial selections (e.g. color picked but no size yet)
    if (!variant) {
      const input = document.getElementById('variant-id');
      if (input) input.value = '';
      this.updateCtaState();
      this.switchImageForPartialSelection();
      return;
    }

    const variantInput = document.getElementById('variant-id');
    const priceEl = document.getElementById('product-price');
    const compareEl = document.getElementById('product-compare-price');
    const saveEl = document.getElementById('product-save-pill');
    const addBtn = document.getElementById('add-to-cart-btn');
    const stickyPrice = document.getElementById('pdp-sticky-price');
    const stickyCompare = document.getElementById('pdp-sticky-compare');
    const mobilePrice = document.getElementById('pdp-mobile-price');
    const stickyMeta = document.getElementById('pdp-sticky-meta');

    variantInput.value = variant.id;
    const price = formatMoney(variant.price);

    if (priceEl) priceEl.textContent = price;
    if (stickyPrice) stickyPrice.textContent = price;
    if (mobilePrice) mobilePrice.textContent = price;

    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (priceEl) priceEl.style.color = onSale ? 'var(--blood)' : 'var(--ink)';
    if (stickyPrice) stickyPrice.style.color = onSale ? 'var(--blood)' : 'var(--ink)';
    if (mobilePrice) mobilePrice.style.color = onSale ? 'var(--blood)' : 'var(--ink)';

    if (compareEl) {
      if (onSale) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (stickyCompare) {
      if (onSale) {
        stickyCompare.textContent = formatMoney(variant.compare_at_price);
        stickyCompare.style.display = '';
      } else if (stickyCompare) {
        stickyCompare.style.display = 'none';
      }
    }
    if (saveEl) {
      if (onSale) {
        const pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        saveEl.textContent = 'SAVE ' + pct + '%';
        saveEl.style.display = '';
      } else {
        saveEl.style.display = 'none';
      }
    }

    // Update add to cart buttons (only if size has been selected)
    const arrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    if (addBtn && this.sizeSelected) {
      addBtn.disabled = !variant.available || this._adding || window.CartPurchase?.controller.locked;
      const addText = addBtn.dataset.addText || 'ADD TO CART';
      const soldText = addBtn.dataset.soldOutText || 'SOLD OUT';
      addBtn.innerHTML = variant.available ? '<span>' + addText + '</span> ' + arrowSvg : '<span>' + soldText + '</span>';
      addBtn.classList.remove('is-no-size');
    }
    if (this.sizeSelected) {
      const stickyArrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
      ['pdp-sticky-add', 'pdp-mobile-add'].forEach(id => {
        const btn = document.getElementById(id);
        if (btn) {
          btn.classList.remove('is-no-size');
          btn.disabled = !variant.available || this._adding || window.CartPurchase?.controller.locked;
          btn.innerHTML = variant.available ? '<span>ADD TO CART</span> ' + stickyArrowSvg : '<span>SOLD OUT</span>';
        }
      });
    }

    // Update sticky meta — both bars, not just the desktop one.
    const metaText = product.options
      .map(opt => (this.selectedOptions[opt] || '').toUpperCase())
      .filter(Boolean)
      .join(' / ');
    if (stickyMeta) stickyMeta.textContent = metaText;
    const mobileMeta = document.getElementById('pdp-mobile-meta');
    if (mobileMeta) mobileMeta.textContent = metaText;

    // Update URL
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    // Switch to variant image if it has one
    this.switchToVariantImage(variant);

    // A different variant can have a different ceiling. Re-clamp so a quantity
    // of 8 chosen on a well-stocked colour doesn't survive a switch to one with
    // 2 left and then fail at checkout.
    this.setQty(this.qty);

    this.renderStackCards();
  },

  /* ---- Image switching for partial option selection (e.g. color only, no size yet) ---- */
  switchImageForPartialSelection() {
    const product = this.product;
    // Find any variant that matches the currently selected options (ignoring nulls)
    const partialMatch = product.variants.find(v =>
      product.options.every((opt, i) => {
        const sel = this.selectedOptions[opt];
        return sel === null || sel === undefined || v['option' + (i + 1)] === sel;
      })
    );
    if (partialMatch) {
      this.switchToVariantImage(partialMatch);
    }
  },

  /* ---- Switch gallery to a variant's featured image ---- */
  switchToVariantImage(variant) {
    const imageId = variant.image_id || (variant.featured_image && variant.featured_image.id);
    // Extract image src for fallback matching
    const imageSrc = variant.featured_image
      ? (typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src)
      : null;

    if (!imageId && !imageSrc) return;

    // Color alternatives share one gallery slot; swatches replace its image.
    if (document.querySelector('.pdp-gallery[data-color-image-slot]')) {
      const image = this.product.images.find(item => String(item.id) === String(imageId));
      const src = image?.src || imageSrc;
      if (!src) return;
      const isCutout = /\/cutout-/.test(src);
      const sized = width => isCutout
        ? (width <= 400 ? src.replace('.webp', '-400.webp') : src)
        : src.replace(/([?&])width=\d+/, '$1width=' + width);
      const alt = image?.alt || this.product.title;
      const thumb = document.querySelector('#pdp-thumb-rail .pdp-thumb');
      if (thumb) {
        thumb.dataset.imageId = String(imageId || 'selected-color');
        thumb.dataset.src = sized(1200);
        thumb.dataset.srcset = isCutout ? '' : [600, 800, 1200, 1600].map(w => `${sized(w)} ${w}w`).join(', ');
        thumb.dataset.alt = alt;
        const preview = thumb.querySelector('img');
        preview.src = sized(180);
        preview.alt = alt;
      }
      const rail = document.getElementById('pdp-mobile-rail');
      const slide = rail?.firstElementChild;
      if (slide) {
        slide.dataset.imageId = String(imageId || 'selected-color');
        const photo = slide.querySelector('img');
        if (isCutout) photo.removeAttribute('srcset');
        else photo.srcset = [480, 640, 800, 1100].map(w => `${sized(w)} ${w}w`).join(', ');
        photo.src = sized(800);
        photo.alt = alt;
        rail.scrollTo({ left: 0, behavior: 'instant' });
      }
      const dotImage = document.querySelector('#pdp-dots .pdp-dot img');
      if (dotImage) dotImage.src = sized(120);
      this.setMainImage(0);
      return;
    }

    // Helper: extract filename stem from a Shopify CDN URL for fuzzy matching
    const getFileStem = (url) => {
      if (!url) return '';
      return url.split('?')[0].split('/').pop().split('.')[0];
    };

    const thumbs = document.querySelectorAll('#pdp-thumb-rail .pdp-thumb');
    let matched = false;

    // Desktop: try image ID first, then fall back to URL matching
    thumbs.forEach((t, i) => {
      if (matched) return;
      if (imageId && String(t.dataset.imageId) === String(imageId)) {
        this.setMainImage(i);
        matched = true;
      }
    });
    if (!matched && imageSrc) {
      const targetStem = getFileStem(imageSrc);
      thumbs.forEach((t, i) => {
        if (matched) return;
        if (t.dataset.src && getFileStem(t.dataset.src) === targetStem) {
          this.setMainImage(i);
          matched = true;
        }
      });
    }

    // Mobile: scroll rail to matching image
    const rail = document.getElementById('pdp-mobile-rail');
    if (rail) {
      const slides = rail.children;
      for (let i = 0; i < slides.length; i++) {
        const slideId = slides[i].dataset.imageId;
        if (imageId && String(slideId) === String(imageId)) {
          rail.scrollTo({ left: i * rail.offsetWidth, behavior: 'smooth' });
          break;
        }
      }
    }
  },

  /* ---- Gallery ---- */
  curateGallery() {
    const thumbs = Array.from(document.querySelectorAll('#pdp-thumb-rail .pdp-thumb'));
    const mockups = thumbs.filter(t => t.dataset.imageId?.startsWith('mockup-'));
    this.galleryOrder = thumbs.map((_, i) => i);
    if (!mockups.length) return;
    const ordered = [thumbs[0], ...mockups, ...thumbs.slice(1).filter(t => !mockups.includes(t))];
    this.galleryOrder = ordered.map(t => thumbs.indexOf(t));
    const rails = ['pdp-thumb-rail', 'pdp-mobile-rail', 'pdp-dots'];
    rails.forEach(id => {
      const rail = document.getElementById(id);
      if (!rail || rail.children.length !== thumbs.length) return;
      const children = Array.from(rail.children);
      this.galleryOrder.forEach((original, index) => {
        const child = children[original];
        if (child.hasAttribute('data-index')) child.dataset.index = index;
        const label = child.getAttribute('aria-label');
        if (label && /^(View|Show) image /.test(label)) child.setAttribute('aria-label', label.replace(/\d+/, String(index + 1)));
        rail.appendChild(child);
      });
    });
  },

  initGallery() {
    const thumbs = document.querySelectorAll('#pdp-thumb-rail .pdp-thumb');
    if (!thumbs.length) return;
    this.currentImageIndex = Math.max(0, Array.from(thumbs).findIndex(t => t.classList.contains('is-selected')));
    const counter = document.getElementById('pdp-img-idx');
    if (counter) counter.textContent = String(this.currentImageIndex + 1).padStart(2, '0');

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        this.setMainImage(parseInt(thumb.dataset.index));
      });
    });

    const prevBtn = document.getElementById('pdp-prev');
    const nextBtn = document.getElementById('pdp-next');
    if (prevBtn) prevBtn.addEventListener('click', () => this.setMainImage(this.currentImageIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => this.setMainImage(this.currentImageIndex + 1));
  },

  updateGalleryCaption(index) {
    const caption = document.getElementById('pdp-gallery-caption');
    const thumb = document.querySelectorAll('#pdp-thumb-rail .pdp-thumb')[index];
    if (caption && thumb) caption.textContent = thumb.dataset.imageId?.startsWith('mockup-') ? caption.dataset.mockupCaption : caption.dataset.photoCaption;
  },

  setMainImage(index) {
    const thumbs = document.querySelectorAll('#pdp-thumb-rail .pdp-thumb');
    if (!thumbs.length) return;
    const total = thumbs.length;
    index = ((index % total) + total) % total;
    this.currentImageIndex = index;

    const thumb = thumbs[index];
    this.updateGalleryCaption(index);
    const mainImg = document.getElementById('pdp-main-img');
    const counter = document.getElementById('pdp-img-idx');

    if (mainImg) {
      mainImg.classList.toggle('is-mockup', (thumb.dataset.imageId || '').startsWith('mockup-'));
      // Two problems here before: the swap faded back in on a timer rather than
      // when the new file had actually arrived, so a slow connection showed an
      // empty frame; and only `src` was assigned, which a browser ignores while
      // a `srcset` is present — the old image would simply have stayed put.
      const nextSrc = thumb.dataset.src;
      const nextSet = thumb.dataset.srcset || '';
      const nextAlt = thumb.dataset.alt || '';
      const request = this.imageRequest = (this.imageRequest || 0) + 1;
      const reveal = () => {
        if (this.currentImageIndex !== index || this.imageRequest !== request) return;
        if (nextSet) mainImg.srcset = nextSet; else mainImg.removeAttribute('srcset');
        mainImg.src = nextSrc;
        mainImg.alt = nextAlt;
        mainImg.style.opacity = '1';
      };
      mainImg.style.opacity = '0';
      const pre = new Image();
      if (nextSet) { pre.srcset = nextSet; pre.sizes = mainImg.sizes || ''; }
      pre.src = nextSrc;
      if (pre.complete) {
        reveal();
      } else {
        pre.onload = reveal;
        // Never leave the gallery blank because one file failed.
        pre.onerror = reveal;
      }
    }
    if (counter) counter.textContent = String(index + 1).padStart(2, '0');
    this.resetInlineZoom?.();
    document.querySelectorAll('[data-pdp-progress]').forEach(bar => { bar.style.width = (100 / thumbs.length) + '%'; bar.style.transform = `translateX(${index * 100}%)`; });
    const zoomLink = document.getElementById('pdp-zoom-open');
    if (zoomLink && thumb.dataset.src) zoomLink.href = thumb.dataset.zoomSrc || thumb.dataset.src.replace(/([?&])width=\d+/, '$1width=2048');

    // Update sticky bar thumbnail
    const stickyImg = document.getElementById('pdp-sticky-img');
    if (stickyImg && thumb.dataset.src) {
      // The thumbnail slot is ~56px; ask the CDN for a small render rather than
      // reusing the 1200px file. Shopify's URL uses &width= after the first
      // param, so match either separator.
      stickyImg.src = thumb.dataset.src.replace(/([?&])width=\d+/, '$1width=120');
    }

    thumbs.forEach(t => {
      t.classList.remove('is-selected');
      t.setAttribute('aria-pressed', 'false');
    });
    thumb.classList.add('is-selected');
    thumb.setAttribute('aria-pressed', 'true');
    if (thumb.getClientRects().length) thumb.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'nearest', inline: 'center' });
  },

  /* ---- Mobile Rail ---- */
  initMobileRail() {
    const rail = document.getElementById('pdp-mobile-rail');
    const dots = document.querySelectorAll('#pdp-dots .pdp-dot');
    if (!rail || !dots.length) return;

    rail.scrollLeft = this.currentImageIndex * rail.clientWidth;
    dots.forEach((dot, i) => {
      const selected = i === this.currentImageIndex;
      dot.classList.toggle('is-active', selected);
      dot.setAttribute('aria-selected', String(selected));
    });
    const initialCounter = document.getElementById('pdp-mobile-idx');
    if (initialCounter) initialCounter.textContent = this.currentImageIndex + 1;

    let activeIndex = this.currentImageIndex;
    let railWidth = rail.clientWidth;
    const resizeRail = new ResizeObserver(() => {
      if (!rail.clientWidth || rail.clientWidth === railWidth) return;
      railWidth = rail.clientWidth;
      rail.scrollLeft = activeIndex * railWidth;
    });
    resizeRail.observe(rail);
    let ticking = false;
    rail.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const idx = Math.round(rail.scrollLeft / rail.offsetWidth);
        activeIndex = idx;
        this.updateGalleryCaption(idx);
        dots.forEach((d, i) => {
          const on = i === idx;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        const counter = document.getElementById('pdp-mobile-idx');
        if (counter) counter.textContent = idx + 1;
        const bar = document.querySelector('[data-pdp-mobile-progress]');
        if (bar) { bar.style.width = (100 / dots.length) + '%'; bar.style.transform = `translateX(${idx * 100}%)`; }
        ticking = false;
      });
    }, { passive: true });

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.index);
        rail.scrollTo({ left: idx * rail.offsetWidth, behavior: 'smooth' });
      });
    });
  },

  /* ---- Quantity ---- */
  /* ---- Quantity ----
     Was: a display <div> plus a hidden field, incremented without any ceiling.
     Nobody could type a number, and + counted past what was in stock — the
     shopper only found out when Shopify rejected the add. Now the visible
     control is the real input, both buttons disable at their bound, and typed
     values are clamped rather than silently posted. */
  qtyMax() {
    const v = this.currentVariant();
    const max = v && typeof v.qty_max === 'number' ? v.qty_max : null;
    if (max === null) return Infinity;
    return Math.max(1, max);
  },

  currentVariant() {
    if (!this.product) return null;
    return this.product.variants.find(v =>
      this.product.options.every((opt, i) => v['option' + (i + 1)] === this.selectedOptions[opt])
    ) || null;
  },

  setQty(next, opts) {
    const input = document.getElementById('product-qty');
    const minus = document.getElementById('pdp-qty-minus');
    const plus = document.getElementById('pdp-qty-plus');
    const note = document.getElementById('pdp-qty-note');
    const max = this.qtyMax();

    let n = parseInt(next, 10);
    if (!isFinite(n)) n = 1;
    const clamped = Math.min(Math.max(1, n), max);
    const wasCapped = n > max;
    this.qty = clamped;

    if (input) input.value = clamped;
    if (input && max !== Infinity) input.setAttribute('max', max);
    else if (input) input.removeAttribute('max');
    if (minus) minus.disabled = clamped <= 1;
    if (plus) plus.disabled = clamped >= max;

    if (note) {
      // Only say something when the shopper actually ran into the ceiling —
      // an always-on "max 10" line is noise on a product nobody buys 10 of.
      if (wasCapped && max !== Infinity) {
        note.textContent = max === 0
          ? 'This option is out of stock.'
          : 'Only ' + max + ' available right now.';
        note.hidden = false;
      } else if (!opts || !opts.keepNote) {
        note.hidden = true;
        note.textContent = '';
      }
    }
    return clamped;
  },

  initQuantity() {
    const input = document.getElementById('product-qty');
    const minus = document.getElementById('pdp-qty-minus');
    const plus = document.getElementById('pdp-qty-plus');
    if (!input) return;

    if (minus) minus.addEventListener('click', () => this.setQty(this.qty - 1));
    if (plus) plus.addEventListener('click', () => this.setQty(this.qty + 1));

    // Typing is free-form until the field is left, so a half-typed "1" on the
    // way to "12" isn't yanked back to 1 mid-keystroke.
    input.addEventListener('input', () => {
      const n = parseInt(input.value, 10);
      if (isFinite(n) && n >= 1) this.qty = Math.min(n, this.qtyMax());
    });
    input.addEventListener('change', () => this.setQty(input.value));
    input.addEventListener('blur', () => this.setQty(input.value));

    this.setQty(this.qty);
  },

  /* ---- Sticky Bottom Bars ---- */
  initStickyBars() {
    const ctaWrap = document.getElementById('pdp-cta-wrap');
    const desktopBar = document.getElementById('pdp-desktop-bottom');
    const mobileBar = document.getElementById('pdp-mobile-bottom');
    if (!ctaWrap) return;

    const observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting;
      if (desktopBar) desktopBar.classList.toggle('is-visible', show);
      if (mobileBar) mobileBar.classList.toggle('is-visible', show);
    }, { threshold: 0, rootMargin: '-80px 0px 0px 0px' });
    observer.observe(ctaWrap);
  },

  /* ---- Sticky Add buttons ---- */
  initStickyAddButtons() {
    ['pdp-sticky-add', 'pdp-mobile-add'].forEach(id => {
      document.getElementById(id)?.addEventListener('click', () => {
        document.getElementById('add-to-cart-btn')?.click();
      });
    });
  },

  /* ---- Share ----
     navigator.share on phones, clipboard everywhere else, and a visible
     confirmation either way — a copy button that does nothing visible reads as
     broken. No third-party buttons: they are tracking scripts wearing a logo. */
  initShare() {
    const btn = document.getElementById('pdp-share');
    const label = document.getElementById('pdp-share-label');
    if (!btn) return;

    const url = btn.dataset.shareUrl;
    const title = btn.dataset.shareTitle || document.title;
    let resetTimer = null;

    const flash = (text) => {
      if (!label) return;
      const original = 'SHARE';
      label.textContent = text;
      btn.classList.add('is-done');
      clearTimeout(resetTimer);
      resetTimer = setTimeout(() => {
        label.textContent = original;
        btn.classList.remove('is-done');
      }, 2200);
    };

    btn.addEventListener('click', async () => {
      if (navigator.share) {
        try {
          await navigator.share({ title: title, url: url });
          return;
        } catch (err) {
          // AbortError just means they closed the sheet — not a failure, and
          // falling through to "copied" would be a lie.
          if (err && err.name === 'AbortError') return;
        }
      }
      try {
        await navigator.clipboard.writeText(url);
        flash('LINK COPIED');
      } catch (err) {
        // Clipboard is origin- and permission-gated; say so rather than
        // pretending it worked.
        flash('COPY FAILED');
      }
    });
  },

  /* ---- Artwork lightbox ----
     The theme had no zoom. The only zoom CSS was scoped `img:not(.is-contain)`
     while every gallery image renders WITH .is-contain, so it had never applied.

     Two things this has to get right:
       - the 2048px sources are fetched on OPEN, never on load, or it would undo
         the responsive-image work on the same template;
       - on the mobile rail a horizontal swipe must not be read as a tap, or
         scrolling the gallery would fling the lightbox open. Hence the movement
         threshold rather than a plain click handler. */
  initZoom() {
    const gallery = document.querySelector('.pdp-gallery');
    if (!gallery) return;
    const reset = () => {
      gallery.querySelectorAll('.is-zoomed').forEach(frame => {
        frame.classList.remove('is-zoomed');
        const image = frame.querySelector('img');
        if (image) image.style.transformOrigin = '';
        frame.querySelector('[aria-pressed]')?.setAttribute('aria-pressed', 'false');
      });
    };
    this.resetInlineZoom = reset;
    const toggle = (frame, event) => {
      const wasZoomed = frame.classList.contains('is-zoomed');
      reset();
      if (wasZoomed) return;
      frame.classList.add('is-zoomed');
      frame.querySelector('[aria-pressed]')?.setAttribute('aria-pressed', 'true');
      pan(frame, event);
    };
    const pan = (frame, event) => {
      if (!frame.classList.contains('is-zoomed')) return;
      const rect = frame.getBoundingClientRect();
      const x = event?.clientX ? Math.max(15, Math.min(85, (event.clientX - rect.left) / rect.width * 100)) : 50;
      const y = event?.clientY ? Math.max(15, Math.min(85, (event.clientY - rect.top) / rect.height * 100)) : 50;
      frame.querySelector('img').style.transformOrigin = `${x}% ${y}%`;
    };
    const desktop = document.getElementById('pdp-zoom-open');
    desktop?.addEventListener('click', event => { event.preventDefault(); toggle(desktop.closest('.pdp-main-image'), event); });
    desktop?.addEventListener('pointermove', event => { if (event.pointerType === 'mouse') pan(desktop.closest('.pdp-main-image'), event); });
    gallery.addEventListener('keydown', event => { if (event.key === 'Escape') reset(); });
    const rail = document.getElementById('pdp-mobile-rail');
    let start;
    rail?.addEventListener('pointerdown', event => { start = { x:event.clientX, y:event.clientY }; }, { passive:true });
    rail?.addEventListener('pointerup', event => {
      if (!start) return;
      const moved = Math.abs(event.clientX - start.x) + Math.abs(event.clientY - start.y);
      start = null;
      const frame = event.target.closest('.pdp-main-image');
      if (frame && moved < 10 && rail.dataset.swiping !== 'true') toggle(frame, event);
    }, { passive:true });
    rail?.addEventListener('pointercancel', () => { start = null; }, { passive:true });
    rail?.addEventListener('scroll', reset, { passive:true });
  },

  /* ---- Size Guide Modal ---- */
  initSizeGuideModal() {
    const backdrop = document.getElementById('pdp-modal-backdrop');
    const modal = document.getElementById('pdp-modal');
    const closeBtn = document.getElementById('pdp-modal-close');
    if (!modal) return;

    let fitLoader;
    const loadFit = () => {
      if (!modal.hasAttribute('data-fit-compare')) return Promise.resolve(null);
      if (!fitLoader) {
        const script = (url, ready) => ready ? Promise.resolve() : new Promise((resolve, reject) => {
          const tag = document.createElement('script'); tag.src = url; tag.async = true;
          tag.onload = resolve; tag.onerror = () => { tag.remove(); reject(new Error('Fit guide could not load')); };
          document.head.appendChild(tag);
        });
        fitLoader = script(modal.dataset.engineUrl, window.IllegalFitEngine)
          .then(() => script(modal.dataset.uiUrl, window.IllegalCloset))
          .then(() => window.IllegalCloset.mount(modal))
          .catch(error => { fitLoader = null; throw error; });
      }
      return fitLoader;
    };

    const open = event => {
      const mode = event?.currentTarget?.matches('[data-fit-open], [data-fit-start]') ? 'compare' : 'visual';
      backdrop?.classList.add('is-open');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      lockBodyScroll();
      loadFit().then(fit => fit?.open(mode)).catch(() => {
        const status = modal.querySelector('#fit-status');
        if (status) status.textContent = 'The fit guide couldn’t load. Tap Compare my shirt to retry.';
      });
    };
    const close = () => {
      backdrop?.classList.remove('is-open');
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      unlockBodyScroll();
    };

    document.getElementById('pdp-size-guide-open')?.addEventListener('click', open);
    document.getElementById('pdp-size-guide-open-2')?.addEventListener('click', open);
    document.querySelectorAll('[data-fit-open], [data-fit-start]').forEach(button => button.addEventListener('click', open));
    closeBtn?.addEventListener('click', close);
    backdrop?.addEventListener('click', close);
    if (new URLSearchParams(location.search).get('size-guide') === '1') {
      requestAnimationFrame(() => document.getElementById('pdp-size-guide-open')?.click());
    }
    try {
      if (localStorage.getItem('illegal_closet_v1')) {
        const reuse = () => loadFit().then(fit => fit?.preloadSaved()).catch(() => {});
        if ('requestIdleCallback' in window) window.requestIdleCallback(reuse, { timeout: 2500 });
        else setTimeout(reuse, 1200);
      }
    } catch (_) {}
  },

  /* ---- CTA State (no size vs ready) ---- */
  updateCtaState() {
    const addBtn = document.getElementById('add-to-cart-btn');
    const arrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    if (this.sizeSelected) {
      // Availability still decides. Leaving this as an unconditional
      // `disabled = false` would re-enable a sold-out product the server had
      // correctly rendered as SOLD OUT, on any page where updateVariant hasn't
      // run yet — i.e. every product without a size to pick.
      const variant = this.currentVariant();
      const available = !!variant && variant.available !== false && !this._adding && !window.CartPurchase?.controller.locked;
      const soldText = (addBtn && addBtn.dataset.soldOutText) || 'SOLD OUT';
      if (addBtn) {
        addBtn.classList.remove('is-no-size');
        addBtn.disabled = !available;
        addBtn.innerHTML = available
          ? '<span>' + (addBtn.dataset.addText || 'ADD TO CART') + '</span> ' + arrowSvg
          : '<span>' + soldText + '</span>';
      }
      ['pdp-sticky-add', 'pdp-mobile-add'].forEach(id => {
        const btn = document.getElementById(id);
        if (btn) {
          btn.classList.remove('is-no-size');
          btn.disabled = !available;
          btn.innerHTML = available
            ? '<span>ADD TO CART</span> ' + arrowSvg
            : '<span>' + soldText + '</span>';
        }
      });
    } else {
      if (addBtn) {
        addBtn.classList.add('is-no-size');
        addBtn.innerHTML = '<span>SELECT A SIZE</span>';
      }
      ['pdp-sticky-add', 'pdp-mobile-add'].forEach(id => {
        const btn = document.getElementById(id);
        if (btn) {
          btn.classList.add('is-no-size');
          btn.innerHTML = '<span>SELECT A SIZE</span>';
        }
      });
    }
  },

  shakeSizeGrid() {
    const grid = document.getElementById('pdp-size-grid');
    if (!grid) return;
    grid.classList.remove('is-prompted');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        grid.classList.add('is-prompted');
      });
    });
    setTimeout(() => grid.classList.remove('is-prompted'), 700);
    // The shake is decorative and is suppressed entirely under
    // prefers-reduced-motion, so the message below is the real feedback.
    this.showSizePrompt();
  },

  /* Persistent, announced explanation of why add-to-cart did nothing. */
  showSizePrompt() {
    const wrap = document.getElementById('pdp-cta-wrap');
    if (!wrap) return;
    let el = document.getElementById('pdp-size-prompt');
    if (!el) {
      el = document.createElement('div');
      el.id = 'pdp-size-prompt';
      el.className = 'pdp-inline-note';
      el.setAttribute('role', 'alert');
      wrap.parentNode.insertBefore(el, wrap);
    }
    el.textContent = 'Choose a size first.';
    el.hidden = false;
  },

  clearSizePrompt() {
    const el = document.getElementById('pdp-size-prompt');
    if (el) el.hidden = true;
  },

  /* ---- Add-to-cart failures ----
     The catch block used to console.error the reason and put "TRY AGAIN" on the
     button, so a shopper hitting Shopify's real limit ("You can only add 3 of
     that to your cart") was told to retry the exact thing that just failed,
     with no way to see why. Same inline-note treatment as the size prompt. */
  showAddError(message) {
    const wrap = document.getElementById('pdp-cta-wrap');
    if (!wrap) return;
    let el = document.getElementById('pdp-add-error');
    if (!el) {
      el = document.createElement('div');
      el.id = 'pdp-add-error';
      el.className = 'pdp-inline-note';
      el.setAttribute('role', 'alert');
      wrap.parentNode.insertBefore(el, wrap);
    }
    el.textContent = message || 'Could not add that to your cart.';
    if (window.CartPurchase?.controller.error) {
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.dataset.cartRetry = '';
      retry.textContent = window.IllegalShirts.purchase_strings.retry;
      const view = document.createElement('a');
      view.href = window.IllegalShirts.routes.cart_url;
      view.textContent = window.IllegalShirts.purchase_strings.view_cart;
      el.append(document.createElement('br'), retry, document.createTextNode(' '), view);
    }
    el.hidden = false;
  },

  clearAddError() {
    const el = document.getElementById('pdp-add-error');
    if (el) { el.hidden = true; el.textContent = ''; }
  },

  /* ---- Form Submit ---- */
  initFormSubmit(form) {
    const addBtn = document.getElementById('add-to-cart-btn');
    const arrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    const checkSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

    // Intercept CTA click — if no size selected, shake instead of submitting
    addBtn?.addEventListener('click', (e) => {
      if (!this.sizeSelected) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.shakeSizeGrid();

        // Scroll to size grid if not in view
        const grid = document.getElementById('pdp-size-grid');
        if (grid) {
          const rect = grid.getBoundingClientRect();
          if (rect.top < 0 || rect.bottom > window.innerHeight) {
            grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => this.shakeSizeGrid(), 400);
          }
        }
        return;
      }
    });

    form.addEventListener('submit', async (e) => {
      if (e.defaultPrevented) return;
      e.preventDefault();
      if (this._adding || window.CartPurchase?.controller.locked) return;
      if (!this.sizeSelected) {
        this.shakeSizeGrid();
        this.showSizePrompt();
        return;
      }
      if (!addBtn) return;
      if (!this.currentVariant()?.available) { this.showAddError(window.IllegalShirts.purchase_strings.unavailable); return; }
      if (!form.reportValidity()) return;
      this._adding = true;

      this.clearAddError();
      addBtn.disabled = true;
      addBtn.innerHTML = '<span>ADDING...</span>';

      let failed = false;
      try {
        const fitCartDetail = { productId: this.product?.id, variantId: this.currentVariant()?.id, size: document.querySelector('#product-form [data-option-role="size"].is-selected')?.dataset.optionValue };
        await IllegalCart.addFromForm(form);
        document.dispatchEvent(new CustomEvent('illegal:cart-added', { detail: fitCartDetail }));
        onAddedToCart(this.product ? this.product.title : 'Item', this.qty);
        addBtn.innerHTML = '<span>ADDED</span> ' + checkSvg;
      } catch (err) {
        failed = true;
        console.error('Add to cart failed:', err);
        // Surface Shopify's own sentence — it names the actual limit.
        this.showAddError(window.CartPurchase.message(err));
        addBtn.innerHTML = '<span>TRY AGAIN</span>';
      } finally {
        this._adding = false;
        this.updateCtaState();
        // Hold the failure state longer than the success flash so the shopper
        // has time to read the reason before the label resets.
        setTimeout(() => this.updateCtaState(), failed ? 5000 : 2000);
      }
    });
  },

  /* ---- Stack & Save ---- */
  initStackAndSave() {
    this.renderStackCards();
  },

  renderStackCards() {
    const grid = document.getElementById('pdp-stack-grid');
    if (!grid) return;

    const variant = this.product.variants.find(v =>
      this.product.options.every((opt, i) => v['option' + (i + 1)] === this.selectedOptions[opt])
    ) || this.product.variants[0];

    const basePrice = variant.price;
    const isSingleDefaultVariant = this.product.variants.length === 1 && variant.title === 'Default Title';
    const unit = !isSingleDefaultVariant && /^t-shirt$/i.test(this.product.type || '') ? 'SHIRT' : 'ITEM';
    const tiers = [
      { qty: 1, label: 'JUST ONE', pct: 0 },
      { qty: 2, label: 'STACK 2', pct: parseInt(grid.closest('.pdp-stack')?.dataset.tier2 || 10) },
      { qty: 3, label: 'STACK 3', pct: parseInt(grid.closest('.pdp-stack')?.dataset.tier3 || 20) },
      { qty: 4, label: 'STACK 4+', pct: parseInt(grid.closest('.pdp-stack')?.dataset.tier4 || 30), best: true }
    ];

    grid.innerHTML = tiers.map(t => {
      // Shopify rounds the discount down once on the full line, in cents.
      // Show the exact quantity total, avoiding fractional per-item prices.
      const subtotal = basePrice * t.qty;
      const saved = Math.floor(subtotal * t.pct / 100);
      const total = subtotal - saved;
      return '<div class="pdp-stack-card' + (t.best ? ' is-best' : '') + '">'
        + (t.best ? '<div class="pdp-stack-flag">BEST DEAL</div>' : '')
        + '<div class="pdp-stack-eyebrow">' + t.label + '</div>'
        + '<div class="pdp-stack-tier"><span class="pdp-stack-num">' + t.qty + '</span><span class="pdp-stack-unit">' + unit + (t.qty > 1 ? 'S' : '') + '</span></div>'
        + '<div class="pdp-stack-meta">'
        + '<div class="pdp-stack-row"><span class="pdp-stack-label">TOTAL</span><span class="pdp-stack-value">' + formatMoney(total) + '</span></div>'
        + '<div class="pdp-stack-row"><span class="pdp-stack-label">DISCOUNT</span><span class="pdp-stack-value' + (t.pct > 0 ? ' is-discount-pct' : ' is-zero') + '">' + (t.pct > 0 ? t.pct + '%' : '-') + '</span></div>'
        + '<div class="pdp-stack-row"><span class="pdp-stack-label">YOU SAVE</span><span class="pdp-stack-value' + (saved > 0 ? '' : ' is-zero') + '">' + (saved > 0 ? formatMoney(saved) : '-') + '</span></div>'
        + '</div></div>';
    }).join('');
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => PDP.init());
} else {
  PDP.init();
}

/* ------ QUICK ADD MODAL ------ */
const cardCutoutMaps = new WeakMap();
function productCutoutMap(card) {
  if (!card) return {};
  if (!cardCutoutMaps.has(card)) {
    let map = {};
    try { map = JSON.parse(card.querySelector('[data-product-cutouts]')?.textContent || '{}'); } catch (_) {}
    cardCutoutMaps.set(card, map);
  }
  return cardCutoutMaps.get(card);
}
function productCutoutSource(src, map) {
  if (!src) return '';
  const key = src.split('?')[0].split('/').pop();
  return (map && map[key]) || src;
}

const QuickAdd = {
  product: null,
  selected: {},
  quantity: 1,

  open() {
    document.getElementById('quick-add-overlay')?.classList.add('open');
    document.getElementById('quick-add-modal')?.classList.add('open');
    lockBodyScroll();
  },

  close() {
    document.getElementById('quick-add-overlay')?.classList.remove('open');
    document.getElementById('quick-add-modal')?.classList.remove('open');
    unlockBodyScroll();
  },

  getSelectedVariant() {
    if (!this.product || !this.optionNames) return null;
    return this.product.variants.find(v => {
      return this.optionNames.every((opt, i) => {
        return v['option' + (i + 1)] === this.selected[opt];
      });
    });
  },

  colorToCSS(name) {
const map = { 'natural': '#f5f0e1', 'heather gray': '#b0b0b0', 'heather grey': '#b0b0b0', 'sports gray': '#b0b0b0', 'sports grey': '#b0b0b0', 'sport gray': '#b0b0b0', 'sport grey': '#b0b0b0', 'charcoal': '#36454f', 'charcoal heather': '#3d4346', 'forrest green': '#228b22', 'forest green': '#228b22', 'royal': '#4169e1', 'royal blue': '#4169e1', 'pale pink': '#f4d5d8', 'bone': '#e3dac9', 'sand': '#c2b280', 'cream': '#fffdd0', 'oatmeal': '#d4c9a8', 'irish green': '#009a44','azalea': '#e96ba8', 'true royal': '#1d4ed8', 'tweed': '#8e857b', };    return map[name.toLowerCase()] || name.toLowerCase().replace(/[\s-]+/g, '');
  },

  getProductImage() {
    const p = this.product;
    if (!p) return '';
    if (p.featured_image) return typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src || '';
    if (p.images && p.images.length > 0) return typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src || '';
    return '';
  },

  updateUI() {
    const variant = this.getSelectedVariant();
    const submitBtn = document.getElementById('quick-add-submit');
    const priceEl = document.getElementById('quick-add-modal-price');

    if (variant) {
      const price = (variant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      if (priceEl) priceEl.textContent = price;
      const mobilePrice = document.getElementById('quick-add-modal-price-mobile');
      if (mobilePrice) mobilePrice.textContent = price;
    }

    // Update image for selected variant
    const imgEl = document.querySelector('#quick-add-image img');
    const imageVariant = variant || this.product?.variants.find(v => this.optionNames.every((name, i) => !this.selected[name] || this.selected[name] === v['option' + (i + 1)]));
    if (imgEl && imageVariant) {
      let src = '';
      if (imageVariant.featured_image) {
        src = typeof imageVariant.featured_image === 'string' ? imageVariant.featured_image : imageVariant.featured_image.src || '';
      }
      if (!src && this.product && this.product.images && this.product.images.length > 0) {
        const colorOpt = this.optionNames?.find(o => o.toLowerCase() === 'color' || o.toLowerCase() === 'colour');
        const colorVal = colorOpt ? this.selected[colorOpt] : null;
        if (colorVal) {
          const colorLower = colorVal.toLowerCase();
          const matchedImg = this.product.images.find(i => {
            const imgSrc = typeof i === 'string' ? i : i.src || '';
            const alt = typeof i === 'object' ? (i.alt || '') : '';
            return alt.toLowerCase().includes(colorLower) || imgSrc.toLowerCase().includes(colorLower.replace(/\s+/g, '-'));
          });
          if (matchedImg) src = typeof matchedImg === 'string' ? matchedImg : matchedImg.src;
        }
        // Fallback: use variant image_id to find matching image
        if (!src && imageVariant.image_id) {
          const matchById = this.product.images.find(i => {
            return (typeof i === 'object' && i.id === imageVariant.image_id);
          });
          if (matchById) src = typeof matchById === 'string' ? matchById : matchById.src;
        }
      }
      src = productCutoutSource(src, this.imageMap);
      if (src && imgEl.src !== src) {
        const imageRequest = this.imageRequest = (this.imageRequest || 0) + 1;
        imgEl.style.opacity = '0.3';
        const preload = new Image();
        preload.onload = () => {
          if (imageRequest !== this.imageRequest || !imgEl.isConnected) return;
          imgEl.src = src;
          imgEl.style.opacity = '1';
          // Update the mobile thumbnail HERE — after the preload resolves
          // and the main image src is actually the new one. The standalone
          // thumb update used to run synchronously below, copying the OLD
          // src before the preload completed, which is why the mobile
          // thumbnail never reflected the chosen color.
          const thumbImg = document.querySelector('.quick-add-thumb img');
          if (thumbImg) thumbImg.src = src;
        };
        preload.onerror = () => { imgEl.style.opacity = '1'; };
        preload.src = src;
      }
    }

    // Update color label
    const colorLabel = document.getElementById('quick-add-color-label');
    if (colorLabel) {
      const colorOpt = this.optionNames.find(o => o.toLowerCase() === 'color' || o.toLowerCase() === 'colour');
      if (colorOpt && this.selected[colorOpt]) colorLabel.textContent = this.selected[colorOpt];
    }

    if (submitBtn) {
      if (!variant) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'UNAVAILABLE';
      } else if (!variant.available) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'SOLD OUT';
      } else {
        submitBtn.disabled = false;
        submitBtn.innerHTML = 'ADD TO CART <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
      }
    }

    // Update selected state on option buttons
    document.querySelectorAll('#quick-add-content .quick-add-option-btn').forEach(btn => {
      const opt = btn.dataset.option;
      const val = btn.dataset.value;
      btn.classList.toggle('selected', this.selected[opt] === val);
      btn.setAttribute('aria-pressed', String(this.selected[opt] === val));
    });
  },

  render(product, opts) {
    // App-configured products expose one Default Title variant in the Ajax
    // API, even when their full form requires component sizes/colors. Route
    // these through that form so Quick Add cannot submit an unconfigured pack.
    const needsProductForm = /custom/i.test(product.handle) || product.requires_selling_plan
      || (product.variants?.length === 1 && product.variants[0].title === 'Default Title');
    if (needsProductForm) {
      window.location.assign((window.Shopify?.routes?.root || '/') + 'products/' + product.handle);
      return;
    }
    product = window.ProductColorMatches?.apply(product) || product;
    this.product = product;
    this.imageMap = opts?.imageMap || {};
    this.imageRequest = (this.imageRequest || 0) + 1;
    this.selected = {};
    this.quantity = 1;

    // Normalize options — Shopify .js returns objects like {name: "Size", ...}
    const optionNames = product.options.map(opt => typeof opt === 'string' ? opt : opt.name);
    const isColour = (o) => {
      const n = String(o).toLowerCase().trim();
      return n === 'color' || n === 'colour';
    };

    // If the card was already showing a colour, open on that colour rather than
    // on the product's first available variant — otherwise picking Bone on the
    // card and hitting QUICK ADD silently offered Black.
    const wantColour = opts && opts.color;
    const colourIdx = optionNames.findIndex(isColour);
    let firstAvailable = null;
    if (wantColour && colourIdx !== -1) {
      const key = 'option' + (colourIdx + 1);
      firstAvailable = product.variants.find(v => v[key] === wantColour && v.available)
        || product.variants.find(v => v[key] === wantColour);
    }
    firstAvailable = firstAvailable || product.variants.find(v => v.available) || product.variants[0];
    if (!firstAvailable) return;

    optionNames.forEach((opt, i) => {
      // Leave Size deliberately unselected. The product page gates add-to-cart
      // behind an explicit size choice to prevent wrong-size orders; pre-picking
      // one here defeated that gate on the very path it opens.
      if (opt.toLowerCase().trim() === 'size' && new Set(product.variants.map(v => v['option' + (i + 1)])).size > 1) {
        this.selected[opt] = null;
        return;
      }
      this.selected[opt] = firstAvailable['option' + (i + 1)];
    });

    // Store normalized option names for variant matching
    this.optionNames = optionNames;

    // Get image — prefer selected variant image, fall back to product image
    let imageSrc = '';
    if (firstAvailable.featured_image) {
      imageSrc = typeof firstAvailable.featured_image === 'string' ? firstAvailable.featured_image : firstAvailable.featured_image.src || '';
    }
    if (!imageSrc) imageSrc = this.getProductImage();
    imageSrc = productCutoutSource(imageSrc, this.imageMap);

    const image = imageSrc
      ? `<img src="${escapeHtml(imageSrc)}" alt="${escapeHtml(product.title)}">`
      : `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;opacity:0.3;font-family:var(--body);font-size:12px;">NO IMAGE</div>`;

    const price = (firstAvailable.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    const comparePrice = firstAvailable.compare_at_price && firstAvailable.compare_at_price > firstAvailable.price
      ? (firstAvailable.compare_at_price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
      : '';

    // Build option pickers
    let optionsHTML = '';
    let hasSizeOption = false;
    const hasRealOptions = !(product.variants.length === 1 && product.variants[0].title === 'Default Title');
    if (hasRealOptions) {
      optionNames.forEach((opt, i) => {
        const values = [...new Set(product.variants.map(v => v['option' + (i + 1)]))];
        const isColor = opt.toLowerCase() === 'color' || opt.toLowerCase() === 'colour';
        const isSize = opt.toLowerCase() === 'size';
        if (isSize) hasSizeOption = true;

        if (isColor) {
          const selectedVal = this.selected[opt];
          optionsHTML += `
            <div class="quick-add-option-group">
              <div class="quick-add-option-label">${opt.toUpperCase()}: <span id="quick-add-color-label" style="color: var(--blood);">${selectedVal}</span></div>
              <div class="quick-add-option-values">
                ${values.map(val => {
                  const isSelected = this.selected[opt] === val;
                  const avail = this.valueAvailable(opt, i, val);
                  const cssColor = this.colorToCSS(val);
                  return `<button type="button" class="quick-add-option-btn quick-add-swatch${isSelected ? ' selected' : ''}${avail ? '' : ' is-unavailable'}" data-option="${escapeHtml(opt)}" data-value="${escapeHtml(val)}" data-swatch-handle="${escapeHtml(product.handle)}" aria-label="${escapeHtml(opt + ': ' + val)}" aria-pressed="${isSelected}"${avail ? '' : ' disabled aria-disabled="true"'} style="background: ${cssColor}; border: 1.5px solid var(--ink);" title="${val}${avail ? '' : ' — sold out'}"></button>`;
                }).join('')}
              </div>
            </div>`;
        } else {
          optionsHTML += `
            <div class="quick-add-option-group">
              <div class="quick-add-option-label" style="display: flex; justify-content: space-between; align-items: baseline;">${opt.toUpperCase()}</div>
              <div class="quick-add-option-values${isSize ? ' is-size-grid' : ''}">
                ${values.map(val => {
                  const isSelected = this.selected[opt] === val;
                  const avail = this.valueAvailable(opt, i, val);
                  return `<button type="button" class="quick-add-option-btn${isSelected ? ' selected' : ''}${avail ? '' : ' is-unavailable'}" data-option="${escapeHtml(opt)}" data-value="${escapeHtml(val)}" data-swatch-handle="${escapeHtml(product.handle)}" aria-label="${escapeHtml(opt + ': ' + val)}" aria-pressed="${isSelected}"${avail ? '' : ' disabled aria-disabled="true"'} style="border: 1.5px solid var(--ink);" title="${val}${avail ? '' : ' — sold out'}">${val}</button>`;
                }).join('')}
              </div>
            </div>`;
        }
      });
    }

    // Determine initial button text
    const firstMissing = hasRealOptions ? optionNames.find(o => !this.selected[o]) : null;
    const sizeSelected = !firstMissing;
    const submitText = sizeSelected
      ? 'ADD TO CART <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>'
      : 'SELECT A ' + String(firstMissing).toUpperCase();

    const content = document.getElementById('quick-add-content');
    content.innerHTML = `
      <div class="quick-add-product-header">
        <div class="quick-add-thumb">${image}</div>
        <div>
          <div class="quick-add-title">${escapeHtml(product.title)}</div>
          <div class="quick-add-price" style="color: ${comparePrice ? 'var(--blood)' : 'var(--ink)'};" id="quick-add-modal-price-mobile">${price} ${comparePrice ? '<span style="text-decoration:line-through;opacity:0.5;color:var(--ink);font-weight:400;font-size:12px;margin-left:4px;">' + comparePrice + '</span>' : ''}</div>
        </div>
      </div>
      <div class="quick-add-image" id="quick-add-image">${image}</div>
      <div class="quick-add-info">
        <div class="quick-add-header">
          <div class="quick-add-title">${escapeHtml(product.title)}</div>
          <div class="quick-add-price" id="quick-add-modal-price">${price}</div>
        </div>
        ${optionsHTML}
        <div class="quick-add-qty-row">
          <div class="quick-add-option-label">QUANTITY</div>
          <div class="quick-add-qty-stepper">
            <button type="button" id="quick-add-qty-minus" aria-label="Decrease quantity" disabled>&minus;</button>
            <input type="number" id="quick-add-qty" value="1" min="1" readonly>
            <button type="button" id="quick-add-qty-plus" aria-label="Increase quantity">&#43;</button>
          </div>
        </div>
        <button type="button" class="quick-add-submit" id="quick-add-submit">
          ${submitText}
        </button>
      </div>`;

    this.open();
    this.setSubmitState();
  },

  /* Is any in-stock variant reachable with this option value, given whatever
     else is currently selected? Sold-out values used to look identical to
     in-stock ones, so shoppers picked a combination that could never be added. */
  valueAvailable(optName, optIndex, value) {
    const isColour = /^(color|colour)$/i.test(String(optName).trim());
    const fixed = (this.optionNames || []).map((o, i) => [i, this.selected[o]])
      // A colour stays selectable when it has stock in another size. Choosing
      // it clears an unavailable size below instead of trapping the shopper.
      .filter(([i, v]) => i !== optIndex && v && !(isColour && /^size$/i.test(String(this.optionNames[i]).trim())));
    return this.product.variants.some(v => {
      if (v['option' + (optIndex + 1)] !== value) return false;
      if (!v.available) return false;
      return fixed.every(([i, val]) => v['option' + (i + 1)] === val);
    });
  },

  /* Re-evaluate every rendered option against the current selection, so a
     size that is sold out in the newly chosen colour becomes unpickable. */
  refreshAvailability() {
    const names = this.optionNames || [];
    document.querySelectorAll('#quick-add-content .quick-add-option-btn').forEach(btn => {
      const opt = btn.dataset.option;
      const idx = names.findIndex(o => o === opt);
      if (idx === -1) return;
      const ok = this.valueAvailable(opt, idx, btn.dataset.value);
      btn.disabled = !ok;
      btn.classList.toggle('is-unavailable', !ok);
      if (ok) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled', 'true');
      // Drop a selection that this change made unreachable
      if (!ok && this.selected[opt] === btn.dataset.value) {
        this.selected[opt] = null;
        btn.classList.remove('selected');
        btn.setAttribute('aria-pressed', 'false');
      }
    });
  },

  /* Which option groups still need a choice before this can be added */
  missingOption() {
    const names = this.optionNames || [];
    const hasReal = !(this.product.variants.length === 1 && this.product.variants[0].title === 'Default Title');
    if (!hasReal) return null;
    return names.find(o => !this.selected[o]) || null;
  },

  setSubmitState() {
    const btn = document.getElementById('quick-add-submit');
    if (!btn) return;
    const missing = this.missingOption();
    const variant = missing ? null : this.getSelectedVariant();
    const arrow = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    if (missing) {
      btn.disabled = false;              // clickable, so it can explain itself
      btn.classList.add('is-gated');
      btn.innerHTML = 'SELECT A ' + missing.toUpperCase();
    } else if (!variant || !variant.available) {
      btn.disabled = true;
      btn.classList.remove('is-gated');
      btn.innerHTML = 'SOLD OUT';
    } else {
      btn.disabled = false;
      btn.classList.remove('is-gated');
      btn.innerHTML = 'ADD TO CART ' + arrow;
    }
  },

  showError(message) {
    const btn = document.getElementById('quick-add-submit');
    if (!btn) return;
    let el = document.getElementById('quick-add-error');
    if (!el) {
      el = document.createElement('div');
      el.id = 'quick-add-error';
      el.className = 'quick-add-error';
      el.setAttribute('role', 'alert');
      btn.parentNode.insertBefore(el, btn);
    }
    el.textContent = message;
    el.hidden = false;
  },

  clearError() {
    const el = document.getElementById('quick-add-error');
    if (el) el.hidden = true;
  },

  async addToCart() {
    if (this._adding || window.CartPurchase?.controller.locked) return;
    this.clearError();

    // Gate: tell the shopper what is missing instead of doing nothing.
    const missing = this.missingOption();
    if (missing) {
      this.showError('Choose a ' + missing.toLowerCase() + ' first.');
      const group = document.querySelector(`.quick-add-option-btn[data-option="${missing}"]`);
      if (group) group.closest('.quick-add-option-group')?.classList.add('needs-choice');
      return;
    }

    const variant = this.getSelectedVariant();
    if (!variant || !variant.available) {
      this.showError('That combination is sold out.');
      return;
    }

    const btn = document.getElementById('quick-add-submit');
    const qtyInput = document.getElementById('quick-add-qty');
    const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

    this._adding = true;
    btn.disabled = true;
    btn.textContent = 'ADDING...';

    try {
      await IllegalCart.addItem(variant.id, qty);
      btn.innerHTML = 'ADDED <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
      setTimeout(() => { this.close(); }, 600);
      onAddedToCart(this.product ? this.product.title : 'Item', qty);
    } catch (err) {
      console.error('Quick Add cart error:', err);
      // Surface Shopify's actual reason — "only 3 left", etc. Retrying blindly
      // fails identically, so the shopper needs to know what went wrong.
      this.showError(window.CartPurchase.message(err));
      btn.disabled = false;
      btn.innerHTML = 'ADD TO CART <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    } finally { this._adding = false; }
  }
};

// Delegated event listeners for quick add — use capture phase so we beat the link
document.addEventListener('click', (e) => {
  // Quantity stepper buttons
  if (e.target.closest('#quick-add-qty-minus')) {
    const input = document.getElementById('quick-add-qty');
    if (input) {
      input.value = Math.max(1, parseInt(input.value) - 1);
      document.getElementById('quick-add-qty-minus').disabled = parseInt(input.value) <= 1;
    }
    return;
  }
  if (e.target.closest('#quick-add-qty-plus')) {
    const input = document.getElementById('quick-add-qty');
    if (input) {
      input.value = parseInt(input.value) + 1;
      document.getElementById('quick-add-qty-minus').disabled = false;
    }
    return;
  }

  // Open modal from product card
  const trigger = e.target.closest('.quick-add-trigger');
  if (trigger) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    const rawUrl = trigger.dataset.productUrl;
    if (!rawUrl) return;
    // Normalize via the shared helper — on recommendation sections product.url
    // carries pr_* tracking params, so "{{ product.url }}.js" can put ".js"
    // inside a query value. cleanProductJsUrl() always yields /products/handle.js.
    const productUrl = cleanProductJsUrl(rawUrl);

    trigger.disabled = true;
    const origHTML = trigger.innerHTML;
    const isFab = trigger.classList.contains('quick-add-fab');
    if (!isFab) {
      trigger.innerHTML = '<span class="font-mono text-xs tracking-widest flex items-center justify-center gap-2"><span style="width:8px;height:8px;border-radius:9999px;border:1.5px solid var(--bone);border-top-color:transparent;display:inline-block;animation:cp-pulse 0.8s linear infinite;"></span> ADDING</span>';
    } else {
      trigger.style.opacity = '0.5';
    }

    fetch(productUrl)
      .then(res => {
        if (!res.ok) throw new Error('Failed to load product');
        return res.json();
      })
      .then(product => {
        // Carry over whatever colour the card is currently showing.
        const card = trigger.closest('.product-card');
        QuickAdd.render(product, { color: card && card.dataset.selectedColor, imageMap: productCutoutMap(card) });
        trigger.disabled = false;
        trigger.innerHTML = origHTML;
        if (isFab) trigger.style.opacity = '';
      })
      .catch(err => {
        console.error('Quick Add error:', err, productUrl);
        if (!isFab) trigger.innerHTML = 'ERROR';
        setTimeout(() => {
          trigger.disabled = false;
          trigger.innerHTML = origHTML;
          if (isFab) trigger.style.opacity = '';
        }, 2000);
      });
    return;
  }

  // Option button click
  const optBtn = e.target.closest('.quick-add-option-btn');
  if (optBtn) {
    e.preventDefault();
    if (optBtn.disabled) return;                       // sold-out value
    QuickAdd.selected[optBtn.dataset.option] = optBtn.dataset.value;
    optBtn.closest('.quick-add-option-group')?.classList.remove('needs-choice');
    QuickAdd.clearError();
    QuickAdd.updateUI();
    QuickAdd.refreshAvailability();                    // other groups depend on this choice
    QuickAdd.setSubmitState();
    return;
  }

  // Submit button click
  if (e.target.closest('#quick-add-submit')) {
    e.preventDefault();
    QuickAdd.addToCart();
    return;
  }
}, true); // capture phase

/* ------ CARD COLOR SWATCH SWITCHING ------ */
(function() {
  const productCache = {};
  const inFlight = {};

  // Fetch + cache a product's .js payload. Safe to call repeatedly (e.g. on
  // hover prefetch AND on click) — concurrent calls share one in-flight promise
  // and resolved results are cached, so a click after a hover resolves instantly.
  function fetchProduct(url) {
    const clean = cleanProductJsUrl(url);
    if (!clean) return Promise.resolve(null);
    if (productCache[clean]) return Promise.resolve(productCache[clean]);
    if (inFlight[clean]) return inFlight[clean];

    inFlight[clean] = fetch(clean)
      .then(res => (res.ok ? res.json() : null))
      .then(data => {
        if (data) productCache[clean] = window.ProductColorMatches.apply(data);
        delete inFlight[clean];
        return data;
      })
      .catch(err => {
        console.error('Swatch product fetch error:', err, clean);
        delete inFlight[clean];
        return null;
      });

    return inFlight[clean];
  }

  // ── PREFETCH ──────────────────────────────────────────────────────────────
  // By the time someone clicks a swatch, their cursor (or finger) was already on
  // the card. Warm the cache then, so the click resolves with no network wait.
  // Capture phase: mouseenter doesn't bubble, so we catch it as it descends.
  function warmCardCache(target) {
    const card = target && target.closest ? target.closest('.product-card') : null;
    if (!card) return;
    const swatch = card.querySelector('.card-swatch[data-product-url]');
    if (swatch) fetchProduct(swatch.dataset.productUrl); // fire-and-forget
  }
  document.addEventListener('mouseenter', (e) => warmCardCache(e.target), true);
  document.addEventListener('touchstart', (e) => warmCardCache(e.target), { passive: true });

  // ── CLICK ───────────────────────────────────────────────────────────────────
  document.addEventListener('click', async (e) => {
    const swatch = e.target.closest('.card-swatch');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    const card = swatch.closest('.product-card');
    if (!card) return;
    if (swatch.classList.contains('is-active')) return; // already selected

    const color = swatch.dataset.color;
    const productUrl = swatch.dataset.productUrl;
    if (!color || !productUrl) return;

    // Update active swatch immediately. Record it on the card too: Quick Add
    // used to open on the product's first available variant regardless, so
    // picking Bone on a card and hitting QUICK ADD offered Black.
    card.querySelectorAll('.card-swatch').forEach(s => s.classList.remove('is-active'));
    swatch.classList.add('is-active');
    card.dataset.selectedColor = color;

    const product = await fetchProduct(productUrl);
    if (!product || card.dataset.selectedColor !== color) return;

    // Find option index for Color
    const optionNames = product.options.map(opt => typeof opt === 'string' ? opt : opt.name);
    const colorIndex = optionNames.findIndex(o => o.toLowerCase() === 'color' || o.toLowerCase() === 'colour');
    if (colorIndex === -1) return;

    // Find first available variant with this color
    const variant = product.variants.find(v => v['option' + (colorIndex + 1)] === color && v.available)
      || product.variants.find(v => v['option' + (colorIndex + 1)] === color);
    if (!variant) return;

    // Swap image - try variant featured_image first, then search product images by alt text or color name
    const img = card.querySelector('.product-card-img');
    if (img) {
      let newSrc = null;
      let newAlt = product.title;
      if (variant.featured_image) {
        newSrc = typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src;
        newAlt = (typeof variant.featured_image === 'object' && variant.featured_image.alt) || product.title;
      }
      if (!newSrc && product.images && product.images.length > 0) {
        const colorLower = color.toLowerCase();
        const matchedImg = product.images.find(i => {
          const src = typeof i === 'string' ? i : i.src || '';
          const alt = typeof i === 'object' ? (i.alt || '') : '';
          return alt.toLowerCase().includes(colorLower) || src.toLowerCase().includes(colorLower.replace(/\s+/g, '-'));
        });
        if (matchedImg) {
          newSrc = typeof matchedImg === 'string' ? matchedImg : matchedImg.src;
          newAlt = (typeof matchedImg === 'object' && matchedImg.alt) || product.title;
        }
      }
      if (newSrc) {
        // The card renders at ~600px; the .js payload hands back the full-res
        // original. Request a card-sized image so the download + decode is small.
        const cutout = productCutoutSource(newSrc, productCutoutMap(card));
        const sized = cutout === newSrc ? sizedImageUrl(newSrc, 600) : cutout;

        // Decode off-screen, then hard-swap with no blank gap. (Old approach
        // set opacity:0 and faded back in only after load, so the card went
        // empty for the whole download — that was most of the visible lag.)
        const next = new Image();
        next.src = sized;
        const apply = () => {
          if (card.dataset.selectedColor !== color) return;
          img.removeAttribute('srcset');
          img.src = sized;
          img.alt = newAlt;
          card.dispatchEvent(new CustomEvent('card:color-image', { detail: { src: sized, alt: newAlt } }));
        };
        if (next.decode) {
          next.decode().then(apply).catch(apply);
        } else {
          next.onload = apply;
          next.onerror = apply;
        }
      }
    }

    // Clean base for variant deep-links (strip tracking params + .js once).
    const base = cleanProductJsUrl(productUrl).replace(/\.js$/, '');

    // Update product link to point to variant
    const link = card.querySelector('.product-card-link');
    if (link) link.href = base + '?variant=' + variant.id;

    // Update title link too
    const titleLink = card.querySelector('.pt-4 a.font-display');
    if (titleLink) titleLink.href = base + '?variant=' + variant.id;

    // Update price
    const priceEl = card.querySelector('.font-mono.text-sm.font-bold');
    if (priceEl && typeof formatMoney === 'function') {
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (onSale) {
        priceEl.innerHTML = '<span class="flex flex-col items-end">'
          + '<span style="color: var(--blood);">' + formatMoney(variant.price) + '</span>'
          + '<span style="text-decoration: line-through; opacity: 0.5; font-weight: normal; font-size: 11px;">' + formatMoney(variant.compare_at_price) + '</span>'
          + '</span>';
      } else {
        priceEl.innerHTML = formatMoney(variant.price);
        priceEl.style.color = 'var(--ink)';
      }
    }
  });
})();

/* ------ INIT: Refresh cart state on load ------
   Every page view used to spend a round trip on /cart.js just to learn what
   Liquid had already rendered — and for most visitors the answer is "empty".
   Seed from the server-rendered count instead and only go to the network when
   there is actually a cart to draw. IllegalCart.open() fetches on first open,
   so a cart filled in another tab still shows correctly the moment it matters. */
function bootCartState() {
  const seeded = window.IllegalShirts && window.IllegalShirts.cart_item_count;
  const count = typeof seeded === 'number' ? seeded : null;
  if (count === 0) {
    syncHeaderCartCount(0);
    return;
  }
  IllegalCart.refresh();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootCartState);
} else {
  bootCartState();
}

/* ============================================================
   COLLECTION PAGE — Tag-based AJAX filtering, no full reloads

   MODEL: every facet (pills, color, size, product type, tags) is a
   tag-based URL. Shopify stacks tags with "+":
     /collections/all                 (no filters)
     /collections/all/sale            (one tag)
     /collections/all/sale+black+xl   (multiple tags, AND)

   Clicking any facet TOGGLES one tag in that +-joined segment and
   AJAX-swaps the whole #cp-section. Sort + pagination params are
   preserved across swaps. Cross-collection links navigate normally.
   ============================================================ */

const CollectionPage = {
  priceTimeout: null,
  _infiniteObserver: null,
  _swapping: false,
  _ajaxBound: false,
  _gridResizeBound: false,
  _sortDocBound: false,

  init() {
    if (!document.getElementById('cp-section')) return;
    this.initSortDropdowns();
    this.initFilterButtons();
    this.initPriceInputs();
    this.initMobileDrawer();
    this.initClearPriceChips();
    this.initResponsiveGrid();
    this.initInfiniteScroll();
    this.initLoadMoreButton();
    this.initAjaxFilters();
  },

  /* ============================================================
     TAG PATH HELPERS
     ============================================================ */

  /* Parse the +-joined tag segment out of a collection path.
     "/collections/all/sale+black" with base "/collections/all"
     -> ["sale", "black"]. Returns [] for the bare collection URL. */
  tagsFromPath(pathname, base) {
    if (!base || pathname === base || !pathname.startsWith(base + '/')) return [];
    const seg = pathname.slice(base.length + 1).split('/')[0]; // first path segment after base
    if (!seg) return [];
    return seg.split('+').map(decodeURIComponent).filter(Boolean);
  },

  /* Build a collection URL from a base + array of tags + a search string. */
  buildTagUrl(base, tags, search) {
    const path = tags.length ? base + '/' + tags.map(encodeURIComponent).join('+') : base;
    return path + (search || '');
  },

  /* The current sort/page-free query string, used to preserve sort + active
     storefront filters across a SAME-collection swap (tag toggle, sort change). */
  currentSearch() {
    const u = new URL(window.location);
    u.searchParams.delete('page'); // never carry pagination across a filter change
    return u.search;
  },

  /* Sort-only query string. Used when a collection PILL switches collections:
     sort is a user preference worth keeping, but storefront filters (filter.*)
     and any price range belong to the OLD collection and must be dropped. */
  sortOnlySearch() {
    const cur = new URL(window.location);
    const out = new URLSearchParams();
    const sort = cur.searchParams.get('sort_by');
    if (sort) out.set('sort_by', sort);
    const s = out.toString();
    return s ? '?' + s : '';
  },

  /* ============================================================
     SORT DROPDOWN
     ============================================================ */
  initSortDropdowns() {
    // Per-trigger listeners: safe to (re)bind, the trigger nodes are replaced
    // on each section swap so old listeners are discarded with the old nodes.
    document.querySelectorAll('[id^="cp-sort-trigger"]').forEach(trigger => {
      const wrapper = trigger.closest('[id^="cp-sort-wrapper"]');
      const panel = wrapper?.querySelector('[id^="cp-sort-panel"]');
      if (!panel) return;

      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = !panel.classList.contains('hidden');
        document.querySelectorAll('.cp-sort-panel').forEach(p => p.classList.add('hidden'));
        if (!isOpen) {
          panel.classList.remove('hidden');
          trigger.setAttribute('aria-expanded', 'true');
        } else {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // Document-level listeners bind ONCE — re-running initSortDropdowns after
    // a swap must not stack duplicate document handlers.
    if (this._sortDocBound) return;
    this._sortDocBound = true;

    // Sort option click
    document.addEventListener('click', (e) => {
      const opt = e.target.closest('.cp-sort-option');
      if (!opt) return;
      e.preventDefault();
      e.stopPropagation();
      const sortValue = opt.dataset.sortValue;
      if (!sortValue) return;

      // Update active state visually on ALL panels
      document.querySelectorAll('.cp-sort-option').forEach(o => {
        o.classList.remove('is-active');
        o.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.cp-sort-option[data-sort-value="' + sortValue + '"]').forEach(o => {
        o.classList.add('is-active');
        o.setAttribute('aria-selected', 'true');
      });

      // Update ALL trigger texts (desktop + mobile)
      const sortLabels = { 'manual': 'FEATURED', 'best-selling': 'BEST SELLING', 'created-descending': 'NEWEST', 'price-ascending': 'LOW-HIGH', 'price-descending': 'HIGH-LOW', 'title-ascending': 'A-Z' };
      const newLabel = sortLabels[sortValue] || 'FEATURED';
      document.querySelectorAll('[id^="cp-sort-trigger"]').forEach(trigger => {
        const spans = trigger.querySelectorAll(':scope > span');
        if (spans.length >= 2) spans[1].textContent = newLabel;
      });

      // Close all panels
      document.querySelectorAll('.cp-sort-panel').forEach(p => p.classList.add('hidden'));

      // Sort changes are an AJAX swap too — keep current tags, set sort_by.
      // Deleting the param for 'manual' handed the collection back to its own
      // default_sort_by, which is only 'manual' if the merchant left it that
      // way. On a collection defaulting to best-selling, picking FEATURED
      // relabelled the control and then sorted by something else. Always say
      // what we mean.
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sortValue);
      url.searchParams.delete('page');
      const target = url.pathname + url.search;
      this.swapToUrl(target, true).catch(() => { window.location = target; });
    });

    // Close panels on outside click
    document.addEventListener('click', (e) => {
      if (e.target.closest('.cp-sort-panel') || e.target.closest('[id^="cp-sort-trigger"]')) return;
      document.querySelectorAll('.cp-sort-panel').forEach(p => p.classList.add('hidden'));
      document.querySelectorAll('[id^="cp-sort-trigger"]').forEach(t => t.setAttribute('aria-expanded', 'false'));
    });
  },

  /* ============================================================
     STOREFRONT FILTER BUTTONS (Search & Discovery <button data-param>)
     Only fire if you actually have storefront filters configured.
     Tag-based stores mostly use the <a href> path below instead, but
     this stays correct for any real ?filter.* facets.
     ============================================================ */
  initFilterButtons() {
    if (this._filterBtnBound) return;
    this._filterBtnBound = true;

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.cp-filter-value');
      if (!btn) return;
      e.preventDefault();
      // Values with a zero count are rendered disabled; a click on one would
      // otherwise still fire and empty the grid.
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

      const param = btn.dataset.param;
      const value = btn.dataset.value;
      const isActive = btn.dataset.active === 'true';

      const url = new URL(window.location);

      if (isActive) {
        const existing = url.searchParams.getAll(param);
        url.searchParams.delete(param);
        existing.filter(v => v !== value).forEach(v => url.searchParams.append(param, v));
      } else {
        url.searchParams.append(param, value);
      }

      url.searchParams.delete('page');
      const target = url.pathname + url.search;
      this.swapToUrl(target, true).catch(() => { window.location = target; });
    });
  },

  /* ============================================================
     PRICE RANGE INPUTS (storefront price filter)
     ============================================================ */
  initPriceInputs() {
    document.querySelectorAll('.cp-price-filter').forEach(input => {
      // Guard against double-binding after a swap by tagging bound inputs.
      if (input._cpBound) return;
      input._cpBound = true;

      input.addEventListener('change', () => {
        this.syncPriceInputs(input);
        clearTimeout(this.priceTimeout);
        this.priceTimeout = setTimeout(() => this.submitPriceFilter(), 600);
      });

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.syncPriceInputs(input);
          clearTimeout(this.priceTimeout);
          this.submitPriceFilter();
        }
      });
    });
  },

  syncPriceInputs(changed) {
    // Desktop and mobile render the same range twice. Keep the hidden copy in
    // sync so its stale value cannot override a mobile edit or cleared value.
    document.querySelectorAll('.cp-price-filter').forEach(input => {
      if (input.dataset.param === changed.dataset.param) input.value = changed.value;
    });
  },

  submitPriceFilter() {
    const url = new URL(window.location);
    const seen = {};
    document.querySelectorAll('.cp-price-filter').forEach(input => {
      const param = input.dataset.param;
      if (seen[param]) return;
      const val = input.value.trim();
      if (val) {
        url.searchParams.set(param, val);
        seen[param] = true;
      } else {
        url.searchParams.delete(param);
      }
    });
    url.searchParams.delete('page');
    const target = url.pathname + url.search;
    this.swapToUrl(target, true).catch(() => { window.location = target; });
  },

  /* ============================================================
     CLEAR PRICE CHIP
     ============================================================ */
  initClearPriceChips() {
    document.querySelectorAll('.cp-clear-price').forEach(btn => {
      if (btn._cpBound) return;
      btn._cpBound = true;
      btn.addEventListener('click', () => {
        const url = new URL(window.location);
        url.searchParams.delete(btn.dataset.minParam);
        url.searchParams.delete(btn.dataset.maxParam);
        url.searchParams.delete('page');
        const target = url.pathname + url.search;
        this.swapToUrl(target, true).catch(() => { window.location = target; });
      });
    });
  },

  /* ============================================================
     MOBILE FILTER DRAWER
     ============================================================ */
  initMobileDrawer() {
    const backdrop = document.getElementById('cp-mobile-backdrop');
    const drawer = document.getElementById('cp-mobile-drawer');
    const openBtn = document.getElementById('cp-mobile-filter-open');
    const closeBtn = document.getElementById('cp-mobile-filter-close');
    const showBtn = document.getElementById('cp-mobile-show-results');

    if (!drawer) return;

    const open = () => {
      if (drawer.classList.contains('is-open')) return;
      drawer.inert = false;
      backdrop?.classList.add('is-open');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openBtn?.setAttribute('aria-expanded', 'true');
      lockBodyScroll();
      closeBtn?.focus({ preventScroll: true });
    };

    const close = () => {
      if (!drawer.classList.contains('is-open')) return;
      backdrop?.classList.remove('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.inert = true;
      openBtn?.setAttribute('aria-expanded', 'false');
      unlockBodyScroll();
      openBtn?.focus({ preventScroll: true });
    };

    drawer.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const targets = [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),summary,[tabindex="0"]')]
        .filter(target => target.getClientRects().length && !target.closest('[hidden]'));
      const first = targets[0], last = targets[targets.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first?.focus();
      }
    });

    // These bind to specific elements that are replaced on swap, so re-running
    // is correct. Expose close() so swapToUrl can shut the drawer after a pick.
    openBtn?.addEventListener('click', open);
    closeBtn?.addEventListener('click', close);
    showBtn?.addEventListener('click', close);
    backdrop?.addEventListener('click', close);
    this._closeMobileDrawer = close;
  },

  /* What to call the things in the grid. Liquid publishes it on #cp-product-grid
     because a design page holds one artwork in many colourways — "8 DESIGNS"
     there is simply wrong. Defaults to the brand's own word. */
  gridUnit(count) {
    const grid = document.getElementById('cp-product-grid');
    const one = (grid && grid.dataset.unitOne) || 'DESIGN';
    const many = (grid && grid.dataset.unitMany) || 'DESIGNS';
    return count === 1 ? one : many;
  },

  /* ============================================================
     RESPONSIVE GRID COLUMNS
     ============================================================ */
  initResponsiveGrid() {
    const apply = () => {
      const grid = document.getElementById('cp-product-grid');
      if (!grid) return;
      const deskCols = grid.dataset.desktopCols || '4';
      const mobCols = grid.dataset.mobileCols || '2';
      const cols = window.innerWidth >= 1024 ? deskCols : mobCols;
      grid.style.gridTemplateColumns = 'repeat(' + cols + ', minmax(0, 1fr))';
    };
    apply();
    if (!this._gridResizeBound) {
      window.addEventListener('resize', apply, { passive: true });
      this._gridResizeBound = true;
    }
  },

  /* ============================================================
     PAGINATION — Load More / Infinite Scroll
     ============================================================ */
  async fetchNextPage(nextUrl) {
    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error('Load failed');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.getElementById('cp-product-grid');
      const currentGrid = document.getElementById('cp-product-grid');
      if (newGrid && currentGrid) {
        currentGrid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
      }

      const newSentinel = doc.getElementById('cp-load-more-sentinel');
      const newBtn = doc.getElementById('cp-load-more-btn');
      const newNextUrl = (newSentinel && newSentinel.dataset.nextUrl) || (newBtn && newBtn.dataset.nextUrl);

      return newNextUrl || null;
    } catch (err) {
      console.error('Load more error:', err);
      return nextUrl; // return same URL to allow retry
    }
  },

  initInfiniteScroll() {
    // Tear down any prior observer so re-running after a swap doesn't stack
    // duplicate observers (which would double-fetch).
    if (this._infiniteObserver) {
      this._infiniteObserver.disconnect();
      this._infiniteObserver = null;
    }

    const sentinel = document.getElementById('cp-load-more-sentinel');
    if (!sentinel) return;

    this._infiniteObserver = new IntersectionObserver(async (entries) => {
      if (!entries[0].isIntersecting) return;

      const nextUrl = sentinel.dataset.nextUrl;
      if (!nextUrl) return;

      sentinel.dataset.nextUrl = '';

      const newNextUrl = await this.fetchNextPage(nextUrl);
      if (newNextUrl) {
        sentinel.dataset.nextUrl = newNextUrl;
      } else {
        sentinel.remove();
        const indicator = document.getElementById('cp-loading-indicator');
        if (indicator) {
          const count = document.querySelectorAll('#cp-product-grid .product-card').length;
          indicator.innerHTML = '<span class="font-mono text-[10px] tracking-[0.3em] opacity-40">END OF THE LINE \u00B7 ' + count + ' ' + this.gridUnit(count) + '</span>';
        }
      }
    }, { rootMargin: '400px' });

    this._infiniteObserver.observe(sentinel);
  },

  initLoadMoreButton() {
    const btn = document.getElementById('cp-load-more-btn');
    if (!btn) return;

    // The button node is replaced on swap, so binding here is fine.
    btn.addEventListener('click', async () => {
      const nextUrl = btn.dataset.nextUrl;
      if (!nextUrl) return;

      btn.dataset.nextUrl = '';
      btn.textContent = 'LOADING...';
      btn.style.opacity = '0.5';
      btn.style.pointerEvents = 'none';

      const newNextUrl = await this.fetchNextPage(nextUrl);
      if (newNextUrl) {
        btn.dataset.nextUrl = newNextUrl;
        btn.textContent = btn.dataset.originalText || 'LOAD MORE';
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
      } else {
        const count = document.querySelectorAll('#cp-product-grid .product-card').length;
        btn.parentElement.innerHTML = '<span class="font-mono text-[10px] tracking-[0.3em] opacity-40">END OF THE LINE \u00B7 ' + count + ' ' + this.gridUnit(count) + '</span>';
      }
    });

    btn.dataset.originalText = btn.textContent.trim();
  },

  /* ============================================================
     AJAX FILTER LINKS — two behaviors, both swap with no reload:

     1. COLLECTION PILLS (links tagged data-cp-collection-pill):
        navigate to that collection's grid in place. SALE is its own
        collection (/collections/sale), so the pill swaps the whole
        section to that collection. Because collections can't stack on
        each other, picking a pill REPLACES the collection context — any
        tag refinement from the previous collection is dropped (there is
        no /collections/sale+new in Shopify). Sidebar checkboxes then
        refine WITHIN whatever collection the pill landed on.

     2. SAME-COLLECTION TAG LINKS (facet fallbacks, chips, the ALL pill):
        toggle one tag in the +-joined path of the CURRENT collection.

     Anything pointing at an unrelated collection that ISN'T a pill (or a
     category tile) navigates normally with a real page load.
     ============================================================ */
  initAjaxFilters() {
    if (this._ajaxBound) return;
    this._ajaxBound = true;

    document.addEventListener('click', (e) => {
      if (e.defaultPrevented) return;
      // Let modified clicks (new tab / new window) behave normally.
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      const section = document.getElementById('cp-section');
      if (!section) return;

      const link = e.target.closest('a[href]');
      if (!link || !section.contains(link)) return;

      // Never hijack: category tiles (real page changes) or sort options.
      if (link.closest('.cp-tile') || link.closest('.cp-sort-panel')) return;

      let dest;
      try { dest = new URL(link.getAttribute('href'), window.location.origin); }
      catch (err) { return; }
      if (dest.origin !== window.location.origin) return;
      if (dest.pathname.includes('/products/')) return;

      // ── Verbatim filter URL: swap to the href exactly as given ──
      // Storefront filter chip "remove" links use Shopify's url_to_remove,
      // which is the canonical URL with that one filter value stripped.
      // Swap to it as-is; do NOT run it through tag-toggle logic (it has
      // filter.* params and no tag segment to toggle).
      if (link.hasAttribute('data-cp-filter-url')) {
        const u = new URL(link.getAttribute('href'), window.location.origin);
        u.searchParams.delete('page');
        const target = u.pathname + u.search;
        e.preventDefault();
        this.swapToUrl(target, true).catch(() => { window.location = target; });
        return;
      }

      // ── Clear-all: strip EVERYTHING (tags, storefront filters, price) ──
      // Marked with data-cp-clear-all. Swaps to the bare collection path,
      // keeping only sort. This is what the CLEAR ALL chip and the sidebar/
      // drawer "clear" links use. Without this they'd fall through to the
      // tag-toggle branch, which clears tags but LEAVES filter.* params —
      // the bug where clicking CLEAR ALL appeared to do nothing.
      if (link.hasAttribute('data-cp-clear-all')) {
        const target = dest.pathname + this.sortOnlySearch();
        e.preventDefault();
        this.swapToUrl(target, true).catch(() => { window.location = target; });
        return;
      }

      // ── Collection pill: swap to that collection, no tag carry-over ──
      // Marked in Liquid with data-cp-collection-pill. The href is the
      // target collection URL (its own canonical path). We swap straight
      // to it. Sort is preserved; tags from the old collection are NOT
      // (they're meaningless against a different collection).
      if (link.hasAttribute('data-cp-collection-pill')) {
        const target = dest.pathname + this.sortOnlySearch();
        e.preventDefault();
        this.swapToUrl(target, true).catch(() => { window.location = target; });
        return;
      }

      // ── Same-collection tag toggle ──
      // Facet fallbacks, chips, and the ALL pill operate on the CURRENT
      // collection only. A link to a different collection that ISN'T a
      // pill falls through to a normal navigation.
      const base = section.dataset.collectionUrl || '';
      const sameCollection = base &&
        (dest.pathname === base || dest.pathname.startsWith(base + '/'));
      if (!sameCollection) return;

      // Figure out which tag this link represents, then toggle it against the
      // live URL's tag set. We recompute instead of trusting the link's href:
      // the Liquid fallbacks only encode a single-tag toggle and drop the rest,
      // which is exactly what was navigating you to a stripped-down view.
      const linkTags = this.tagsFromPath(dest.pathname, base);
      const curTags = this.tagsFromPath(window.location.pathname, base);

      let nextTags;
      if (linkTags.length === 0) {
        // Bare collection URL = a CLEAR-ALL / clear link. Empty the tag set.
        nextTags = [];
      } else {
        // The tag being toggled is the last segment the link adds.
        const tag = linkTags[linkTags.length - 1];
        nextTags = curTags.includes(tag)
          ? curTags.filter(t => t !== tag)   // already on -> remove
          : curTags.concat(tag);             // not on   -> add
      }

      const target = this.buildTagUrl(base, nextTags, this.currentSearch());

      e.preventDefault();
      this.swapToUrl(target, true).catch(() => { window.location = target; });
    });

    // Back / forward re-run the swap against whatever the URL now is.
    window.addEventListener('popstate', () => {
      this.swapToUrl(window.location.pathname + window.location.search, false)
        .catch(() => window.location.reload());
    });
  },

  /* ============================================================
     THE SWAP — fetch a collection/tag/filter URL and replace the
     whole #cp-section. Updates header, sticky pills (active states),
     chips, grid, pagination, sidebar + drawer facets in one shot.
     ============================================================ */
  async swapToUrl(url, push) {
    // In-flight guard: ignore a new request while one runs. (async fn, so this
    // still returns a resolved promise — callers can .catch safely.)
    if (this._swapping) return;
    this._swapping = true;

    const liveSection = document.getElementById('cp-section');
    const grid = document.getElementById('cp-product-grid');
    if (grid) grid.style.opacity = '0.4';

    try {
      const response = await fetch(url, { headers: { 'X-Requested-With': 'fetch' } });
      if (!response.ok) throw new Error('Filter fetch failed: ' + response.status);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const freshSection = doc.getElementById('cp-section');
      if (!freshSection || !liveSection) throw new Error('No #cp-section in response');

      // Preserve which sidebar/drawer facets the user had expanded.
      const openFacets = this.snapshotDetails();
      // ...and whether the mobile filter drawer was open. It lives inside
      // #cp-section, so the swap below destroys it; the old code papered over
      // that by closing it after every pick, which meant a phone could only
      // ever apply one filter per open. Keeping it open also means the
      // "SHOW N DESIGNS" button re-renders with the live count.
      const drawerWasOpen = !!document.getElementById('cp-mobile-drawer')?.classList.contains('is-open');

      // Replace the entire section's innards in one shot. Correct whether we
      // filtered the current collection or just changed sort.
      liveSection.innerHTML = freshSection.innerHTML;
      liveSection.dataset.collectionUrl =
        freshSection.dataset.collectionUrl || liveSection.dataset.collectionUrl;

      this.restoreDetails(openFacets);

      // Re-bind element-specific listeners for the freshly injected markup.
      // (Document-delegated handlers — ajax links, filter buttons, sort options,
      // quick-add — survive because they're bound to `document`.)
      this.initSortDropdowns();
      this.initMobileDrawer();
      this.initResponsiveGrid();
      this.initInfiniteScroll();
      this.initLoadMoreButton();
      this.initPriceInputs();
      this.initClearPriceChips();

      // Put the mobile drawer back the way the shopper left it. The scroll
      // lock is untouched here on purpose — it was never released, so
      // re-locking would leave the counter permanently above zero.
      if (drawerWasOpen) {
        const freshDrawer = document.getElementById('cp-mobile-drawer');
        const freshBackdrop = document.getElementById('cp-mobile-backdrop');
        if (freshDrawer) {
          freshDrawer.inert = false;
          freshDrawer.classList.add('is-open');
          freshDrawer.setAttribute('aria-hidden', 'false');
          document.getElementById('cp-mobile-filter-open')?.setAttribute('aria-expanded', 'true');
          document.getElementById('cp-mobile-filter-close')?.focus({ preventScroll: true });
        }
        if (freshBackdrop) freshBackdrop.classList.add('is-open');
      }

      // Update the address bar so reload + back/forward work.
      if (push) window.history.pushState({ cpFilter: true }, '', url);

      // After a filter change, nudge the grid into view if the user scrolled
      // past. Not while the drawer is covering it.
      if (push && !drawerWasOpen) {
        const anchor = document.getElementById('cp-grid-anchor');
        if (anchor) {
          const top = anchor.getBoundingClientRect().top + window.scrollY - 140;
          if (window.scrollY > top + 40) window.scrollTo({ top, behavior: 'smooth' });
        }
      }
    } finally {
      const g = document.getElementById('cp-product-grid');
      if (g) g.style.opacity = '';
      this._swapping = false;
    }
  },

  /* ---- Remember / restore expanded <details> facets across a swap ---- */
  snapshotDetails() {
    const map = {};
    document.querySelectorAll('#cp-sidebar-facets details.cp-facet, #cp-drawer-facets details.cp-facet')
      .forEach(d => {
        const key = (d.querySelector('summary') || {}).textContent;
        if (key) map[key.trim()] = d.open;
      });
    return map;
  },

  restoreDetails(map) {
    document.querySelectorAll('#cp-sidebar-facets details.cp-facet, #cp-drawer-facets details.cp-facet')
      .forEach(d => {
        const key = ((d.querySelector('summary') || {}).textContent || '').trim();
        if (key in map) d.open = map[key];
      });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => CollectionPage.init());
} else {
  CollectionPage.init();
}

/* ============================================================
   CART PAGE — AJAX Controls, Progress Bar, Upsells
   ============================================================ */

const CartPage = {
  thresholdCents: 0,

  init() {
    if (!document.getElementById('cart-page')) return;

    // Parse threshold from settings (injected via Liquid)
    const bar = document.getElementById('cart-shipping-bar');
    this.thresholdCents = parseInt(bar?.dataset?.threshold || '10000');

    this.initQuantityButtons();
    this.initRemoveButtons();
    this.initUpsellRail();
    this.initCloseLinks();
    this.loadRecommendations();

    // Reflect the initial server-rendered quantities in the minus buttons.
    this.syncMinusButtons();
  },

  /* ---- Disable a line's minus button when its qty is 1 ----
     Pass a specific line element to sync just that row, or omit to sync all.
     Visually communicates the floor-at-1 rule instead of silently no-op'ing. */
  syncMinusButtons(scope) {
    const rows = scope
      ? [scope]
      : document.querySelectorAll('#cart-page .cart-line-item');
    rows.forEach(row => {
      if (!row) return;
      const input = row.querySelector('.cart-qty-input');
      const minus = row.querySelector('.cart-qty-btn[data-action="decrease"]');
      if (!input || !minus) return;
      const atMin = (parseInt(input.value, 10) || 1) <= 1;
      minus.disabled = atMin;
      minus.setAttribute('aria-disabled', atMin ? 'true' : 'false');
      minus.classList.toggle('is-disabled', atMin);
    });
  },

  /* ---- Close / Continue Shopping links ----
     Both the desktop "CONTINUE SHOPPING" text link and the mobile X icon
     share .cart-close-link. Default href is "/" (home) as the no-JS fallback.
     With JS, prefer going BACK to where the user came from — but only if the
     referrer is on this same domain, so we never bounce someone off-site
     from clicking a "close" button. Deep links / external referrers / no
     referrer all fall back to home. */
  initCloseLinks() {
    document.querySelectorAll('.cart-close-link').forEach(link => {
      link.addEventListener('click', (e) => {
        // Let modifier clicks (cmd-click, middle-click, etc.) follow the
        // href normally so "open in new tab" still works.
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();

        if (document.referrer) {
          try {
            const ref = new URL(document.referrer);
            if (ref.origin === window.location.origin) {
              window.history.back();
              return;
            }
          } catch (err) { /* malformed referrer — fall through to home */ }
        }
        window.location.href = '/';
      });
    });
  },

  /* ---- Quantity +/- ---- */
  initQuantityButtons() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.cart-qty-btn');
      if (!btn) return;
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

      const key = btn.dataset.key;
      const action = btn.dataset.action;
      const lineItem = btn.closest('.cart-line-item');
      const input = lineItem.querySelector('.cart-qty-input');
      if (!input) return;

      let qty = parseInt(input.value) || 1;
      if (action === 'increase') qty++;
      else if (action === 'decrease') qty = qty - 1;

      // Floor at 1. The stepper never removes — that's the REMOVE button's job.
      // Trying to go below 1 is a no-op (and we make sure the input shows 1).
      if (qty < 1) {
        input.value = 1;
        return;
      }

      input.value = qty;
      lineItem.classList.add('is-updating');
      this.syncMinusButtons(lineItem);

      this.queueQuantity(key, qty);
    });

    // Also handle direct input changes
    document.addEventListener('change', (e) => {
      if (!e.target.classList.contains('cart-qty-input')) return;
      const key = e.target.dataset.key;
      // Match the native cart: an explicit zero removes the line.
      const qty = e.target.value === '' ? NaN : Number(e.target.value);
      const lineItem = e.target.closest('.cart-line-item');
      if (lineItem) lineItem.classList.add('is-updating');
      // Typed values are already deliberate, so go almost straight out — the
      // short delay only exists to merge a change event with a stray click.
      this.queueQuantity(key, qty, 50);
    });
  },

  /* ---- Remove button ---- */
  initRemoveButtons() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('#cart-page .cart-line-remove');
      if (!btn) return;
      if (!IllegalCart.controller) return;
      e.preventDefault();
      if (IllegalCart.controller.locked) return;

      const key = btn.dataset.key;
      const lineItem = btn.closest('.cart-line-item');
      if (lineItem) lineItem.classList.add('is-removing');
      this.queueQuantity(key, 0);
    });
  },

  /* ---- AJAX update ----
     Every stepper click used to POST immediately. Tapping + five times fired
     five overlapping requests to /cart/change.js, and because each carries an
     absolute quantity rather than a delta, whichever response landed last won
     — which is not necessarily the last click. Coalesce per line, then serialize
     the requests so every edited row receives its confirmed state. */
  queueQuantity(key, quantity, delay) {
    IllegalCart.controller?.change(key, quantity, delay);
  },

  updateSummary(cart) {
    const subtotal = document.getElementById('cart-summary-subtotal');
    const total = document.getElementById('cart-summary-total');
    const mobileTotal = document.getElementById('cart-mobile-total');

    if (subtotal) subtotal.textContent = formatMoney(cart.original_total_price);
    if (total) total.textContent = formatMoney(cart.total_price);
    if (mobileTotal) mobileTotal.textContent = formatMoney(cart.total_price);
    const row = document.getElementById('cart-summary-discount-row');
    const discount = document.getElementById('cart-summary-discount');
    if (row) row.style.display = cart.total_discount > 0 ? '' : 'none';
    if (discount) discount.textContent = '-' + formatMoney(cart.total_discount || 0);
    const shipping = document.getElementById('cart-summary-shipping');
    if (shipping) shipping.textContent = shipping.dataset.calculatedLabel;
  },

  updateProgressBar() {},

  /* ---- Stack & Save bar live-update ----
     The bar's structure is server-rendered with item_count baked into Liquid:
     progress fill width, four tier dots (filled/unfilled), status copy, and
     the right-side "SAVING X%" badge. Mirrors the Liquid logic so the bar
     reflects post-update cart state without a page reload — same role
     updateProgressBar plays for the shipping bar. */
  updateStackBar(cart) {
    const bar = document.querySelector('.cart-stack-bar');
    if (!bar) return;

    const cnt = cart.item_count;
    const tier2 = parseInt(bar.dataset.tier2 || '10', 10);
    const tier3 = parseInt(bar.dataset.tier3 || '20', 10);
    const tier4 = parseInt(bar.dataset.tier4 || '30', 10);

    let currentDiscount = 0;
    if (cnt >= 4) currentDiscount = tier4;
    else if (cnt >= 3) currentDiscount = tier3;
    else if (cnt >= 2) currentDiscount = tier2;

    // Progress fill: 25% per item up to 100% at 4+
    let fillPct = 0;
    if (cnt >= 4) fillPct = 100;
    else if (cnt === 3) fillPct = 75;
    else if (cnt === 2) fillPct = 50;
    else if (cnt === 1) fillPct = 25;
    const fill = bar.querySelector('.cart-stack-fill');
    if (fill) fill.style.width = fillPct + '%';

    // Tier dots — each dot's data-tier is the item count it represents
    bar.querySelectorAll('.cart-stack-dot').forEach(dot => {
      const tier = parseInt(dot.dataset.tier, 10);
      dot.style.background = cnt >= tier ? 'var(--blood)' : 'var(--ink)';
    });

    // Status copy under the bar
    const status = bar.querySelector('.cart-stack-status');
    if (status) {
      let text = '';
      if (cnt >= 4) text = 'MAX DISCOUNT UNLOCKED \u2014 ' + tier4 + '% OFF';
      else if (cnt === 3) text = 'ADD 1 MORE FOR ' + tier4 + '% OFF';
      else if (cnt === 2) text = 'ADD 1 MORE FOR ' + tier3 + '% OFF';
      else if (cnt === 1) text = 'ADD 1 MORE FOR ' + tier2 + '% OFF';
      status.textContent = text;
    }

    // Right-side SAVING X% badge — hide when no discount earned yet
    const savingWrap = bar.querySelector('.cart-stack-saving');
    const savingValue = bar.querySelector('.cart-stack-saving-value');
    if (savingWrap) savingWrap.style.display = currentDiscount > 0 ? '' : 'none';
    if (savingValue) savingValue.textContent = currentDiscount + '%';

  },

  updateCounts(cart) {
    const pageCount = document.getElementById('cart-page-count');
    const mobileCount = document.getElementById('cart-mobile-count');
    const drawerCount = document.getElementById('cart-drawer-count');

    const s = cart.item_count === 1 ? '' : 'S';
    if (pageCount) pageCount.textContent = cart.item_count + ' ITEM' + s;
    if (mobileCount) mobileCount.textContent = cart.item_count + ' item' + s.toLowerCase();
    if (drawerCount) drawerCount.textContent = cart.item_count;
    // Same reason as IllegalCart.render: the badge needs hiding at zero and
    // has a screen-reader label to keep in step.
    syncHeaderCartCount(cart.item_count);
  },

  /* ---- Re-render the cart page from the server ----
     Adding from the cart page's own upsell rail (or the recommendations below
     it) went through Quick Add, which refreshes the drawer — and the drawer
     alone. On the cart page itself nothing changed: no new line, no new
     totals, no toast (that is suppressed here on purpose). The shopper clicked
     ADD and the page sat there.

     Section rendering gives us the freshly-rendered Liquid for this section,
     so the line list, properties, tier bar and summary all come back correct
     without a full reload. If it isn't available, fall back to reloading —
     still better than showing a stale cart. */
  async refreshFromServer() {
    const host = document.getElementById('cart-page')?.closest('.shopify-section');
    const sectionId = host && host.id.replace(/^shopify-section-/, '');
    if (!sectionId) { window.location.reload(); return; }

    try {
      const url = new URL(window.location.pathname, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      const res = await fetch(url.toString());
      if (!res.ok) throw new Error('section render ' + res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#cart-page');
      const current = document.getElementById('cart-page');
      if (!fresh || !current) throw new Error('cart section not found in response');
      current.replaceWith(fresh);
      // Quantity, remove and quick-add handlers are delegated on document and
      // survive the swap; these two bind to specific ids and do not.
      this.initUpsellRail();
      this.syncMinusButtons();
      this.loadRecommendations();
    } catch (err) {
      console.error('Cart page refresh failed:', err);
      window.location.reload();
    }
  },

  /* ---- Upsell Rail scroll ---- */
  initUpsellRail() {
    const rail = document.getElementById('cart-upsell-rail');
    const prev = document.getElementById('upsell-prev');
    const next = document.getElementById('upsell-next');
    if (!rail) return;

    const scrollAmount = 260;
    if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -scrollAmount, behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => rail.scrollBy({ left: scrollAmount, behavior: 'smooth' }));
  },

  /* ---- Load Recommendations via AJAX ---- */
  async loadRecommendations() {
    const container = document.getElementById('cart-recs');
    if (!container) return;

    const productId = container.dataset.productId;
    const cartIds = (container.dataset.cartProductIds || '').split(',');
    if (!productId) return;

    try {
      const res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=8`);
      if (!res.ok) return;
      const data = await res.json();
      let products = data.products || [];

      // Filter out products already in cart
      products = products.filter(p => !cartIds.includes(String(p.id)));
      if (products.length === 0) return;

    let html = '';
    html += '<div class="cart-upsell-header" style="margin-bottom: 24px;">';
      html += '<div>';
      html += '<div class="font-mono text-[10px] tracking-[0.3em] mb-2" style="color: var(--blood);">YOU MIGHT ALSO LIKE</div>';
      html += '<h2 class="font-display text-2xl sm:text-3xl lg:text-4xl leading-[0.9] tracking-tight" style="color: var(--ink);">MORE<br>OFFENSES.</h2>';
      html += '</div>';
      html += '</div>';
      html += '<div class="cart-upsell-rail-wrap">';
      html += '<div class="cart-upsell-nav">';
      html += '<button type="button" class="cart-upsell-arrow" id="recs-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg></button>';
      html += '<button type="button" class="cart-upsell-arrow" id="recs-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg></button>';
      html += '</div>';
      html += '<div class="cart-upsell-rail" id="cart-recs-rail">';

      products.forEach(p => {
        // Titles go through escapeHtml: a straight quote in a product name
        // ("THE 5\" INSEAM") closed the alt and aria-label attributes early and
        // spilled the rest of the title into the tag as attributes.
        const title = escapeHtml(p.title);
        const url = escapeHtml(p.url);
        // The image is inside a link whose text is the title, so naming it again
        // makes a screen reader read the product twice.
        const img = p.featured_image ? `<img src="${escapeHtml(p.featured_image)}" alt="" loading="lazy">` : '';
        const price = formatMoney(p.price);
        html += `<div class="cart-upsell-card">
          <a href="${url}" class="cart-upsell-img" tabindex="-1" aria-hidden="true">${img}</a>
          <div class="cart-upsell-info">
            <a href="${url}" class="cart-upsell-title">${title}</a>
            <div class="cart-upsell-price">${price}</div>
          </div>
          <button type="button" class="cart-upsell-add quick-add-trigger" data-product-url="${url}.js" aria-label="Quick add ${title}">+ ADD</button>
        </div>`;
      });

      html += '</div></div>';
      container.innerHTML = html;

      // Wire up carousel arrows
      const rail = document.getElementById('cart-recs-rail');
      const prevBtn = document.getElementById('recs-prev');
      const nextBtn = document.getElementById('recs-next');
      if (rail && prevBtn && nextBtn) {
        const scrollAmt = () => rail.querySelector('.cart-upsell-card')?.offsetWidth + 16 || 260;
        prevBtn.addEventListener('click', () => rail.scrollBy({ left: -scrollAmt(), behavior: 'smooth' }));
        nextBtn.addEventListener('click', () => rail.scrollBy({ left: scrollAmt(), behavior: 'smooth' }));
      }
    } catch (err) {
      console.error('Recommendations error:', err);
    }
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => CartPage.init());
} else {
  CartPage.init();
}

/* ====== STICKY PROGRESS TRACKER ====== */
const StickyProgress = {
  update(itemCount) {
    const count = Math.max(0, Number(itemCount) || 0);
    const progress = document.getElementById('sticky-progress');
    if (progress) progress.hidden = progress.dataset.excluded === 'true' || count === 0;
    const countEl = document.getElementById('sp-cart-count');
    if (countEl) countEl.textContent = count;
  }
};

// Hook into IllegalCart.render to update sticky progress
(() => {
  const origRender = IllegalCart.render.bind(IllegalCart);
  IllegalCart.render = function(cart) {
    origRender(cart);
    StickyProgress.update(cart.item_count, cart.total_price, cart.total_discount);
  };
})();


// Initialize on page load with current cart count
(function initStickyProgress() {
  function run() {
    const countEl = document.getElementById('sp-cart-count');
    if (countEl) {
      const progress = document.getElementById('sticky-progress');
      StickyProgress.update(parseInt(countEl.textContent, 10) || 0, Number(progress?.dataset.total) || 0, Number(progress?.dataset.discount) || 0);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* ============================================================
   ACCESSIBILITY — dialog keyboard support (WCAG 2.2 AA)
   ------------------------------------------------------------
   The cart drawer, quick-add modal and size-guide modal were mouse-only:
   no Escape key, no focus containment, and focus was never returned to the
   control that opened them — so a keyboard or screen-reader user could tab
   straight out of an open dialog into the page behind it.

   This observes each dialog's open state rather than rewriting the existing
   open/close functions, so it layers on without touching cart or PDP logic.
   ============================================================ */
(function () {
  const FOCUSABLE = [
    'a[href]', 'button:not([disabled])', 'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])', 'textarea:not([disabled])', 'summary', '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  // id, the class that marks it open, and how to close it
  // IllegalCart / IllegalMenu / QuickAdd are declared with `const` at the top
  // level of this file. In a classic script that creates a LEXICAL global, not a
  // property of `window` — so `window.IllegalCart` is undefined and an optional
  // call through it silently does nothing. Reference the bindings directly
  // (same file, same scope) and fall back to clicking the dialog's own close
  // control if a module is ever removed.
  const DIALOGS = [
    {
      id: 'cart-drawer', openClass: 'open', trigger: '[data-open-cart-drawer]',
      close: () => (typeof IllegalCart !== 'undefined' && IllegalCart.close)
        ? IllegalCart.close()
        : document.querySelector('#cart-drawer .cart-close')?.click()
    },
    {
      id: 'menu-drawer', openClass: 'open', trigger: '#menu-open-btn',
      close: () => (typeof IllegalMenu !== 'undefined' && IllegalMenu.close)
        ? IllegalMenu.close()
        : document.querySelector('#menu-drawer .menu-close')?.click()
    },
    {
      id: 'quick-add-modal', openClass: 'open',
      close: () => (typeof QuickAdd !== 'undefined' && QuickAdd.close)
        ? QuickAdd.close()
        : document.querySelector('.quick-add-close')?.click()
    },
    {
      id: 'pdp-modal', openClass: 'is-open',
      close: () => document.getElementById('pdp-modal-close')?.click()
    },
    {
      id: 'pdp-zoom', openClass: 'is-open',
      close: () => document.getElementById('pdp-zoom-close')?.click()
    },

  ];

  let active = null;          // currently open dialog element
  let activeConfig = null;
  let lastTrigger = null;     // element focused before opening

  function visibleFocusable(root) {
    return Array.from(root.querySelectorAll(FOCUSABLE)).filter((el) => {
      if (el.closest('[hidden]')) return false;
      const style = window.getComputedStyle(el);
      if (style.visibility === 'hidden' || style.display === 'none') return false;
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  /* Can this element actually take focus right now? A node that is still in the
     document but sits inside a closed dialog will silently swallow .focus() and
     leave focus on <body> — which is how closing Quick Add used to strand
     keyboard users at the top of the page. */
  function focusableNow(el) {
    if (!el || el === document.body || !document.contains(el)) return false;
    if (el.disabled) return false;
    if (el.closest('[hidden]')) return false;
    const style = window.getComputedStyle(el);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    return el.offsetWidth > 0 || el.offsetHeight > 0;
  }

  function onOpen(el, config) {
    if (active === el) return;
    // Remember what to return focus to, unless focus is already inside the
    // dialog — or inside ANY dialog. Quick Add hands off to the cart drawer, so
    // the drawer used to record Quick Add's submit button as its trigger, and
    // then tried to focus it after Quick Add had closed.
    const current = document.activeElement;
    const inAnyDialog = current && current.closest &&
      DIALOGS.some((d) => current.closest('#' + d.id));
    if (config.trigger) {
      lastTrigger = document.querySelector(config.trigger);
    } else if (!el.contains(current) && !inAnyDialog) {
      lastTrigger = current;
    }
    active = el;
    activeConfig = config;
    el.setAttribute('aria-hidden', 'false');

    // Move focus in without yanking the page around
    const targets = visibleFocusable(el);
    const first = targets.find(t => t.hasAttribute('data-dialog-initial-focus')) || targets.find((t) => !t.hasAttribute('data-a11y-skip-autofocus')) || el;
    if (first === el && !el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    try { first.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
  }

  function onClose(el) {
    if (active !== el) return;
    active = null;
    activeConfig = null;
    el.setAttribute('aria-hidden', 'true');

    if (focusableNow(lastTrigger)) {
      try { lastTrigger.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    } else {
      // The trigger is gone (its card was swapped out) or is itself hidden.
      // Land on the main content region rather than dropping focus on <body>,
      // which would send the next Tab back to the top of the page.
      const main = document.getElementById('main-content');
      if (main) {
        if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
        try { main.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      }
    }
    lastTrigger = null;
  }

  // Escape closes; Tab cycles inside the open dialog
  document.addEventListener('keydown', (e) => {
    if (!active) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();   // IllegalMenu also binds Escape unconditionally
      activeConfig?.close?.();
      return;
    }

    if (e.key !== 'Tab') return;
    const targets = visibleFocusable(active);
    if (!targets.length) return;
    const first = targets[0];
    const last = targets[targets.length - 1];

    const inside = active.contains(document.activeElement);
    if (!inside) {
      // Focus escaped the dialog (or never entered) — pull it back rather than
      // letting Tab walk through the page behind an open dialog.
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
    } else if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // Watch each dialog's class list for its open/closed state
  DIALOGS.forEach((config) => {
    const el = document.getElementById(config.id);
    if (!el) return;
    el.setAttribute('aria-hidden', el.classList.contains(config.openClass) ? 'false' : 'true');

    new MutationObserver(() => {
      if (el.classList.contains(config.openClass)) onOpen(el, config);
      else onClose(el);
    }).observe(el, { attributes: true, attributeFilter: ['class'] });
  });

  /* Decorative SVGs inside already-labelled controls shouldn't be announced.
     Anything with its own accessible name is left alone. */
  function hideDecorativeIcons(root) {
    const scope = root || document;
    const mark = (svg) => {
      if (svg.querySelector('title')) return;
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    };
    // querySelectorAll matches descendants only, so an injected node that IS an
    // <svg> was never processed.
    if (scope.matches && scope.matches('svg:not([aria-hidden]):not([role="img"])')) mark(scope);
    scope.querySelectorAll('svg:not([aria-hidden]):not([role="img"])').forEach(mark);
  }

  function run() {
    hideDecorativeIcons();
    // Cart lines and quick-add content are injected after load
    new MutationObserver((records) => {
      records.forEach((r) => r.addedNodes.forEach((n) => {
        if (n.nodeType === 1) hideDecorativeIcons(n);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* ------ RECENTLY VIEWED ------
   A ~900 product catalogue means the thing someone liked four pages ago is
   effectively gone: there is no back button that survives a filter change, and
   nothing in the theme remembered anything between page loads.

   What is stored is ONLY the handle. Storing the title, image or price would
   mean rendering a stale price the next time the merchant runs a sale — the
   list is re-fetched live from /products/<handle>.js every time it draws, so a
   product that was renamed, repriced, sold out or deleted shows the truth or
   drops out of the list entirely.

   The rail is `hidden` until it actually has cards, so a first-time visitor,
   a private window, a browser with storage blocked, and JS off all render the
   same thing: nothing. */
const RecentlyViewed = {
  KEY: 'illegal:recent',
  // Keep more than we show, so removing the product you are looking at (and
  // dropping any that 404) still leaves a full rail.
  MAX: 12,
  SHOW: 6,

  read() {
    try {
      const raw = JSON.parse(localStorage.getItem(this.KEY));
      return Array.isArray(raw) ? raw.filter((h) => typeof h === 'string' && h) : [];
    } catch (e) {
      // Private mode, storage disabled, or someone else's JSON in our key.
      return [];
    }
  },

  write(list) {
    try {
      localStorage.setItem(this.KEY, JSON.stringify(list.slice(0, this.MAX)));
    } catch (e) { /* over quota or storage disabled — the feature just stops */ }
  },

  record(handle) {
    if (!handle) return;
    const list = this.read().filter((h) => h !== handle);
    list.unshift(handle);
    this.write(list);
  },

  clear() {
    try { localStorage.removeItem(this.KEY); } catch (e) { /* nothing to do */ }
    document.querySelectorAll('[data-recently-viewed]').forEach((el) => {
      el.hidden = true;
      const rail = el.querySelector('[data-rv-rail]');
      if (rail) rail.innerHTML = '';
    });
  },

  card(p) {
    const img = p.featured_image
      ? '<img src="' + escapeHtml(sizedImageUrl(p.featured_image, 400)) + '" alt="" loading="lazy" decoding="async" width="400" height="400">'
      : '';
    // Products carry a price range; `price` alone would read as exact on a
    // product whose variants differ.
    const price = p.price_varies
      ? 'FROM ' + formatMoney(p.price_min)
      : formatMoney(p.price);
    return '<a class="rv-card" href="' + escapeHtml(p.url) + '">'
      + '<span class="rv-card-img">' + img
      + (p.available ? '' : '<span class="rv-card-out font-mono">SOLD OUT</span>')
      + '</span>'
      + '<span class="rv-card-title">' + escapeHtml(p.title) + '</span>'
      + '<span class="rv-card-price font-mono">' + price + '</span>'
      + '</a>';
  },

  async render(el) {
    const rail = el.querySelector('[data-rv-rail]');
    if (!rail) return;
    const exclude = el.getAttribute('data-exclude') || '';
    const root = (el.getAttribute('data-root') || '/').replace(/\/$/, '');
    const wanted = this.read().filter((h) => h !== exclude).slice(0, this.SHOW);
    if (!wanted.length) return;

    const results = await Promise.all(wanted.map(async (handle) => {
      try {
        const res = await fetch(root + '/products/' + encodeURIComponent(handle) + '.js');
        if (!res.ok) return { handle, gone: res.status === 404 };
        return { handle, product: await res.json() };
      } catch (e) {
        // Offline or blocked: leave the handle alone and draw nothing for it.
        return { handle };
      }
    }));

    // A 404 means unpublished or deleted. Forget it rather than re-requesting
    // it on every page for the rest of this browser's life.
    const gone = results.filter((r) => r.gone).map((r) => r.handle);
    if (gone.length) this.write(this.read().filter((h) => gone.indexOf(h) === -1));

    const products = results.filter((r) => r.product).map((r) => r.product);
    if (!products.length) return;

    rail.innerHTML = products.map((p) => this.card(p)).join('');
    el.hidden = false;
  },

  init() {
    // Record before rendering, so the product you are on is already in the list
    // by the time you leave it — and is excluded from its own rail.
    const json = document.getElementById('product-json');
    let current = '';
    if (json) {
      try { current = (JSON.parse(json.textContent) || {}).handle || ''; } catch (e) { /* malformed */ }
    }
    if (current) this.record(current);

    document.querySelectorAll('[data-recently-viewed]').forEach((el) => {
      if (current && !el.hasAttribute('data-exclude')) el.setAttribute('data-exclude', current);
      const clear = el.querySelector('[data-rv-clear]');
      if (clear) clear.addEventListener('click', () => this.clear());
      this.render(el);
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => RecentlyViewed.init());
} else {
  RecentlyViewed.init();
}

/* ------ SCROLL REVEAL ------
   The gate is in <head> (see layout/theme.liquid): this module only runs when
   .reveal-on is already on <html>, which means IntersectionObserver exists and
   the visitor has not asked for reduced motion. If this file never loads, the
   gate takes the class back off after four seconds and the page is just a page.

   Targets are curated here rather than sprinkled through fifteen Liquid files,
   so what animates is one list in one place. The hero is deliberately not on
   it — hiding the largest element above the fold would push Largest Contentful
   Paint out for the sake of a fade. */
const Reveal = {
  TARGETS: [
    '[data-reveal]',
    '.cg-grid > a',     // collection tiles (no class of their own)
    '.di-tile',         // design index
    '.merch-tile',      // non-apparel rail
    '.help-claims',
    '.help-contact',
    '.help-policies'
  ].join(','),

  init() {
    window.__revealBooted = true;
    if (!document.documentElement.classList.contains('reveal-on')) return;

    this.io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        // One-way: re-hiding on scroll-up is a well-known way to make a page
        // feel broken rather than alive.
        this.io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

    this.scan();

    // The collection grid appends pages as you scroll and the cart rail injects
    // cards, so new nodes have to be picked up after the fact.
    const mo = new MutationObserver((records) => {
      records.forEach((r) => r.addedNodes.forEach((n) => {
        if (n.nodeType === 1) this.scan(n);
      }));
    });
    mo.observe(document.body, { childList: true, subtree: true });
  },

  scan(root) {
    if (!this.io) return;
    const scope = root || document;
    const found = [];
    if (scope.matches && scope.matches(this.TARGETS)) found.push(scope);
    if (scope.querySelectorAll) found.push(...scope.querySelectorAll(this.TARGETS));

    found.forEach((el) => {
      if (el.dataset.revealBound) return;
      el.dataset.revealBound = '1';
      // Stagger by position within the row, not within the page: a 40th card
      // must not wait two seconds for its turn.
      const siblings = el.parentElement ? Array.from(el.parentElement.children) : [];
      const i = siblings.indexOf(el);
      el.style.setProperty('--reveal-delay', (i > -1 ? (i % 4) * 70 : 0) + 'ms');

      // This file is deferred, so the page has already painted by the time we
      // get here. Marking something on screen as hidden and animating it back
      // is a visible flash, not an entrance — anything already in view is
      // revealed in the same frame it is marked, so it never changes.
      const above = el.getBoundingClientRect().top < window.innerHeight;
      el.setAttribute('data-reveal', '');
      if (above) {
        el.classList.add('is-revealed');
        return;
      }
      this.io.observe(el);
    });
  }
};

/* ------ BACK TO TOP ------
   The collection grid loads infinitely, so "the top" — where search and the
   navigation live — can be several fetches and many thousands of pixels away
   with no way back but scrolling. */
const BackToTop = {
  init() {
    const btn = document.getElementById('back-to-top');
    if (!btn) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Both bottom bars slide in with a transform, so "showing" means the top
    // edge has come up into the viewport. Measured rather than assumed, because
    // the consent bar's height depends on how the text wraps.
    const lift = () => {
      let up = 0;
      document.querySelectorAll('.cc-banner, .pdp-mobile-bottom, .pdp-desktop-bottom, #sticky-progress, .cart-mobile-checkout').forEach((bar) => {
        const r = bar.getBoundingClientRect();
        if (!bar.hidden && r.height && r.top >= 0 && r.top < window.innerHeight - 1 && getComputedStyle(bar).visibility !== 'hidden') {
          up = Math.max(up, window.innerHeight - r.top + 12);
        }
      });
      btn.style.setProperty('--btt-lift', up + 'px');
    };

    let ticking = false;
    const update = () => {
      ticking = false;
      // A page and a half: enough that scrolling back is a real cost, late
      // enough that the button is not competing with the hero.
      const footer = document.querySelector('footer');
      const footerNear = footer && footer.getBoundingClientRect().top < window.innerHeight + 24;
      const show = window.scrollY > window.innerHeight * 1.5 && !footerNear;
      btn.inert = !show;
      if (show) {
        lift();
        // `hidden` keeps it out of the accessibility tree until it has ever
        // been needed; after that visibility does the same job and can be
        // transitioned, so it is not put back.
        if (btn.hidden) {
          btn.hidden = false;
          // Next frame, so the transition has a start value to animate from
          // rather than the button simply appearing fully formed.
          requestAnimationFrame(() => { if (!btn.inert) btn.classList.add('is-visible'); });
        } else {
          btn.classList.add('is-visible');
        }
      } else {
        btn.classList.remove('is-visible');
      }
    };

    const scheduleUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    // Cart updates can reveal or resize a bottom bar without a scroll event.
    // Re-measure its actual position so the button always clears its controls.
    const bottomBars = document.querySelectorAll('.cc-banner, .pdp-mobile-bottom, .pdp-desktop-bottom, #sticky-progress, .cart-mobile-checkout');
    const barResize = new ResizeObserver(scheduleUpdate);
    const barState = new MutationObserver(scheduleUpdate);
    bottomBars.forEach(bar => {
      barResize.observe(bar);
      barState.observe(bar, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
      bar.addEventListener('transitionend', scheduleUpdate);
    });
      const footer = document.querySelector('footer');
      if (footer) new IntersectionObserver(update, { rootMargin: '24px' }).observe(footer);
      update();

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' });
      // Scrolling alone leaves a keyboard user's focus thousands of pixels down
      // the page, so the next Tab drops them straight back. Move focus with the
      // viewport, to the same target the skip link uses.
      const main = document.getElementById('main-content');
      if (main) main.focus({ preventScroll: true });
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => { Reveal.init(); BackToTop.init(); });
} else {
  Reveal.init();
  BackToTop.init();
}
